import React, { useState, useEffect, useCallback, useRef } from "react";
import { 
  CreateTable,
  SuccessMessage,
  FailMessage,
  ConfirmationModal,
  Loading,
  FormatValueToDecimal,

  TaxTypeSelect,
  TaxationCodeSelect,
  // AccountsPayablesChartOfAccountsSelect, 
  ChartOfAccountsSelect, 
  BankChartOfAccountsSelect,
  VendorSelect, CustomerSelect,
  DetectMimeTypeFromBase64, HandleFileUpload, DownloadFile,
  DateSelect, PaymentStatusSelectWithAll,
  PaymentMethodSelect2,
  
  CheckbookSelect, CheckbookFromUpdateSelect, 
  BankSelect,
  CHECK_PAYMENT_METHOD,
} from "../../common/APICommon";
import { apiUrl } from "../../utils/Configuration";
import axios from 'axios';
import { motion, AnimatePresence } from "framer-motion";
import NoAccess from "../NoAccess";
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { JournalHeader } from "../Journals/JournalHeader";
// MUI Icons
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ListAltIcon from '@mui/icons-material/ListAlt';
import VisibilityIcon from '@mui/icons-material/Visibility';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import PostAddIcon from '@mui/icons-material/PostAdd';
import NotInterestedIcon from '@mui/icons-material/NotInterested';

export const Expenses = ({active}) => {
//#region Others
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [failMessage, setFailMessage] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [search, setSearch] = useState("");

  const handleSearch = (value) => {
    setSearch(value);
    setCurrentPage(1)
    const lowerValue = value.toLowerCase();

    const filtered = filteredData.filter(
      (item) =>
        item.expenseNumber?.toLowerCase().includes(lowerValue) ||
        item.referenceNumber?.toLowerCase().includes(lowerValue) ||
        item.vendorName1?.toLowerCase().includes(lowerValue) ||
        item.customerName1?.toLowerCase().includes(lowerValue)
    );

    setData(filtered);
  };
//#endregion







//#region Filters
  const [showFilterForm, setShowFilterForm] = useState(false);
  const [customerFilter, setCustomerFilter] = useState(null);
  const [vendorFilter, setVendorFilter] = useState(null);
  const [statusFilter, setStatusFilter] = useState("All");
  const openFilterForm = () => {
    setShowFilterForm(true);
  }
  const closeFilterForm = () => {
    setShowFilterForm(false);
  }
//#endregion








//#region Variables
  const [selectedData, setSelectedData] = useState(null);

  const [expenseAccounts, setExpenseAccounts] = useState([]);
  const [paidThroughAccount, setPaidThroughAccount] = useState(null);
  const [paidAmount, setPaidAmount] = useState(0);
  const [vendor, setVendor] = useState(null);
  const [customer, setCustomer] = useState(null);
  const [expenseNumber, setExpenseNumber] = useState("xxxxxx");
  const today = new Date().toISOString().split("T")[0];
  const [expenseDate, setExpenseDate] = useState(today);
  const [notes, setNotes] = useState("");
  const [uploadedFile, setUploadedFile] = useState("");
  const [vat, setVAT] = useState(12);
  const [discounts, setDiscounts] = useState(0);
  const [zeroRated, setZeroRated] = useState(0);
  const [ewt, setEWT] = useState(0);
  const [subTotal, setSubTotal] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [paymentMethod, setPaymentMethod] = useState(null);
  const [referenceNumber, setReferenceNumber] = useState("");

  //checkbook transactions
  const [bank, setBank] = useState(null);
  const [checkbook, setCheckbook] = useState(null);

  const resetVariables = () => {
    setExpenseAccounts([]);
    setPaidThroughAccount(null);
    setPaidAmount(0);
    setVendor(null);
    setCustomer(null);
    setExpenseDate(today);
    setExpenseNumber("xxxxxx");
    setReferenceNumber("");
    setNotes("");
    setUploadedFile("");
    setVAT(0);
    setDiscounts(0);
    setZeroRated(0);
    setEWT(0);
    setSubTotal(0);
    setTotalAmount(0);
    setPaymentMethod(null);
    setBank(null);
    setCheckbook(null);

    setSelectedData(null);
  }

  const fetchDataById = useCallback(async (_data) => {
    try {
      const response = await axios.get(`${apiUrl}/api/Expense/${_data?.id}` , {
        headers: { 'Content-Type': 'application/json'}
      })
        
      return response.data
    } catch (error) {
      console.error('Error fetching data:', error);
      return null
    }
  }, []);
//#endregion









// #region Add function
  const [showAddForm, setShowAddForm] = useState(false);
  
  const openAddForm = () => {
    setShowAddForm(true);
  }
  const closeAddForm = () => {
    setShowAddForm(false);
    resetVariables();
  }

  /* const generateNumber = useCallback(async () => {
    try {
      const response = await axios.get(`${apiUrl}/api/Expense/generate-number` , {
        headers: { 'Content-Type': 'application/json'}
      })
        
      return (response.data)
    } catch (error) {
      console.error('Error fetching data:', error);
      return ""
    }
  }, []); */

  const addHandleClick = async () => {
    setLoading(true)

    // const _number = await generateNumber();
    // setExpenseNumber(_number?.number)

    setLoading(false)
    openAddForm()
  }

  const handleAddData = async () => {
    const _totalAmount = expenseAccounts?.reduce((acc, item) => acc + (Number(item.totalAmount) || 0), 0) || 0;
    const _amount = expenseAccounts?.reduce((acc, item) => acc + (Number(item.amount) || 0), 0) || 0;
    const _vat = expenseAccounts?.reduce((acc, item) => acc + (Number(item.vat) || 0), 0) || 0;
    const _discounts = expenseAccounts?.reduce((acc, item) => acc + (Number(item.discounts) || 0), 0) || 0;
    const _ewt = expenseAccounts?.reduce((acc, item) => acc + (Number(item.ewt) || 0), 0) || 0;

    const data = {
      expenseAccounts: expenseAccounts,
      paidThroughAccountId: paidThroughAccount?.id,
      paidAmount: paidAmount,
      vendorId: vendor?.vendorId,
      customerId: customer?.customerId,
      expenseNumber: expenseNumber,
      paymentMethodId: paymentMethod?.id,
      referenceNumber: referenceNumber,
      notes: notes,
      expenseDate: expenseDate,
      uploadedFile: uploadedFile?.base64,
      vat: _vat,
      discounts: _discounts,
      zeroRated: zeroRated,
      ewt: _ewt,
      subTotal: _amount,
      totalAmount: _totalAmount,
      checkbookId: checkbook?.id,
      createdDate: new Date(),
      createdBy: accountData?.id,
    };

    try {
      setLoading(true);

      await axios.post(`${apiUrl}/api/Expense`, data, {
          headers: { 'Content-Type': 'application/json' }
      });
      
      await fetchData();
      setSuccessMessage("Data added successfully!");
    } catch (error) {
      console.error('There was a problem adding data:', error);
      const errorMessage = JSON.parse(error.response.request.responseText).message;
      setFailMessage(`Failed to add data: ${errorMessage}`);
    } finally {
      setLoading(false);
    }
  } 
//#endregion






// #region Update function
  const [showUpdateForm, setShowUpdateForm] = useState(false);
  
  const openUpdateForm = () => {
    setShowUpdateForm(true);
  }
  const closeUpdateForm = () => {
    setShowUpdateForm(false);
    resetVariables();
  }

  const editHandleClick = async (data) => {
    setLoading(true)
    const _data = await fetchDataById(data)
    setSelectedData(_data);

    setExpenseAccounts(_data.expenseAccounts ?? []);
    setPaidThroughAccount(_data.paidThroughAccount ?? null);
    setPaidAmount(_data.paidAmount ?? 0);
    setVendor(_data.vendor ?? null);
    setCustomer(_data.customer ?? null);
    setExpenseNumber(_data.expenseNumber ?? "");
    setReferenceNumber(_data.referenceNumber ?? "");
    setNotes(_data.notes ?? "");
    setExpenseDate(_data.expenseDate ?? null);
    setUploadedFile(_data.uploadedFile
            ? {
                base64: _data.uploadedFile,
                contentType: DetectMimeTypeFromBase64(
                  _data.uploadedFile
                ),
                fileName: `UploadedFile.${DetectMimeTypeFromBase64(
                  _data.uploadedFile
                ).split("/")[1]}`
              }
            : null)
    setVAT(_data.vat ?? 0);
    setDiscounts(_data.discounts ?? 0);
    setZeroRated(_data.zeroRated ?? 0);
    setEWT(_data.ewt ?? 0);
    setSubTotal(_data.subTotal ?? 0);
    setTotalAmount(_data.totalAmount ?? 0);

    setPaymentMethod(_data.paymentMethod ?? null);
    setBank(_data.bank ?? null);
    setCheckbook(_data.checkbook ?? null);

    setLoading(false)
    openUpdateForm();
  }

  const handleUpdateData = async () => {
    const _totalAmount = expenseAccounts?.reduce((acc, item) => acc + (Number(item.totalAmount) || 0), 0) || 0;
    const _amount = expenseAccounts?.reduce((acc, item) => acc + (Number(item.amount) || 0), 0) || 0;
    const _vat = expenseAccounts?.reduce((acc, item) => acc + (Number(item.vat) || 0), 0) || 0;
    const _discounts = expenseAccounts?.reduce((acc, item) => acc + (Number(item.discounts) || 0), 0) || 0;
    const _ewt = expenseAccounts?.reduce((acc, item) => acc + (Number(item.ewt) || 0), 0) || 0;

    const data = {
      expenseAccounts: expenseAccounts,
      paidThroughAccountId: paidThroughAccount?.id,
      paidAmount: paidAmount,
      vendorId: vendor?.vendorId,
      customerId: customer?.customerId,
      expenseNumber: expenseNumber,
      paymentMethodId: paymentMethod?.id,
      referenceNumber: referenceNumber,
      notes: notes,
      expenseDate: expenseDate,
      uploadedFile: uploadedFile?.base64,
      vat: _vat,
      discounts: _discounts,
      zeroRated: zeroRated,
      ewt: _ewt,
      subTotal: _amount,
      totalAmount: _totalAmount,

      checkbookId: checkbook?.id,
      
      updatedDate: new Date(),
      updatedBy: accountData?.id,
    };

    try {
      setLoading(true);

      await axios.post(`${apiUrl}/api/Expense/update/${selectedData?.id}`, data, {
          headers: { 'Content-Type': 'application/json' }
      });
      
      await fetchData();
      setSuccessMessage("Data updated successfully!");
    } catch (error) {
      console.error('There was a problem adding data:', error);
      const errorMessage = JSON.parse(error.response.request.responseText).message;
      setFailMessage(`Failed to add data: ${errorMessage}`);
    } finally {
      setLoading(false);
    }
  } 
//#endregion








// #region View function
  const [showViewForm, setShowViewForm] = useState(false);
  
  const openViewForm = () => {
    setShowViewForm(true);
  }
  const closeViewForm = () => {
    setShowViewForm(false);
    resetVariables();
  }

  const viewHandleClick = async (data) => {
    setLoading(true)
    const _data = await fetchDataById(data)
    setSelectedData(_data);

    setExpenseAccounts(_data.expenseAccounts ?? []);
    setPaidThroughAccount(_data.paidThroughAccount ?? null);
    setPaidAmount(_data.paidAmount ?? 0);
    setVendor(_data.vendor ?? null);
    setCustomer(_data.customer ?? null);
    setExpenseNumber(_data.expenseNumber ?? "");
    setReferenceNumber(_data.referenceNumber ?? "");
    setNotes(_data.notes ?? "");
    setExpenseDate(_data.expenseDate ?? null);
    setUploadedFile(_data.uploadedFile
            ? {
                base64: _data.uploadedFile,
                contentType: DetectMimeTypeFromBase64(
                  _data.uploadedFile
                ),
                fileName: `UploadedFile.${DetectMimeTypeFromBase64(
                  _data.uploadedFile
                ).split("/")[1]}`
              }
            : null)
    setVAT(_data.vat ?? 0);
    setDiscounts(_data.discounts ?? 0);
    setZeroRated(_data.zeroRated ?? 0);
    setEWT(_data.ewt ?? 0);
    setSubTotal(_data.subTotal ?? 0);
    setTotalAmount(_data.totalAmount ?? 0);

    setPaymentMethod(_data.paymentMethod ?? null);
    setBank(_data.bank ?? null);
    setCheckbook(_data.checkbook ?? null);

    setLoading(false)
    openViewForm();
  }
//#endregion








// #region View Expense Account
  const [selectedExpenseAccount, setSelectedExpenseAccount] = useState(null);
  const [showViewExpenseAccountForm, setShowViewExpenseAccountForm] = useState(false);
  
  const openViewExpenseAccountForm = () => {
    setShowViewExpenseAccountForm(true);
  }
  const closeViewExpenseAccountForm = () => {
    setShowViewExpenseAccountForm(false);
    setSelectedExpenseAccount(null);
  }

  const viewExpenseAccountHandleClick = async (data) => {
    setLoading(true)
    const _data = await fetchDataById(data);

    setSelectedExpenseAccount(_data?.expenseAccounts ?? []);

    setLoading(false)
    openViewExpenseAccountForm();
  }
// #endregion







// #region View Paid Through Account
  const [selectedPaidThroughAccount, setSelectedPaidThroughAccount] = useState(null);
  const [showViewPaidThroughAccountForm, setShowViewPaidThroughAccountForm] = useState(false);
  
  const openViewPaidThroughAccountForm = () => {
    setShowViewPaidThroughAccountForm(true);
  }
  const closeViewPaidThroughAccountForm = () => {
    setShowViewPaidThroughAccountForm(false);
    setSelectedPaidThroughAccount(null);
  }

  const viewPaidThroughAccountHandleClick = async (data) => {
    setLoading(true)
    const _data = await fetchDataById(data);

    setSelectedPaidThroughAccount(_data?.paidThroughAccounts ?? []);

    setLoading(false)
    openViewPaidThroughAccountForm();
  }
// #endregion









// #region Post function
  const [showPostForm, setShowPostForm] = useState(false);
  
  const openPostForm = () => {
    setShowPostForm(true);
  }
  const closePostForm = () => {
    setShowPostForm(false);
    resetVariables();
  }

  const postHandleClick = async (data) => {
    setLoading(true)
    const _data = await fetchDataById(data)
    setSelectedData(_data);

    setLoading(false)
    openPostForm();
  }
//#endregion






// #region Void
  const [showVoidForm, setShowVoidForm] = useState(false);

  const openVoidForm = () => {
    setShowVoidForm(true);
  }
  const closeVoidForm = () => {
    setShowVoidForm(false);
    setSelectedData(null);
  }

  const voidHandleClick = async (data) => {
    setSelectedData(data);
    openVoidForm();
  }

  const handleVoidStatus = async () => {
    try {
      setLoading(true);

      const _data = {
        id: selectedData?.id,
        status: "Void"
      }

      await axios.post(`${apiUrl}/api/Expense/change-status`, _data, {
          headers: { 'Content-Type': 'application/json' }
      });
      
      await fetchData();
      setSuccessMessage("Data updated successfully!");
    } catch (error) {
      console.error('There was a problem adding data:', error);
      const errorMessage = JSON.parse(error.response.request.responseText).message;
      setFailMessage(`Failed to change data: ${errorMessage}`);
    } finally {
      setLoading(false)
    }
  }
// #endregion








//#region Table data
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState([]);

  const headers = [
    'EXPENSE NUMBER', 
    'EXPENSE ACCOUNT/S', 
    'ADJUSTMENTS', 
    'EXPENSE AMOUNT', 
    'PAID THROUGH ACCOUNT', 
    'VENDOR', 
    // 'CUSTOMER', 
    'STATUS', 
    'ACTIONS',
  ]
  const accessors = [
    'expenseNumber', 
    'expenseAccounts', 
    'adjustments', 
    'expense', 
    'paidThrough', 
    'vendor', 
    // 'customer', 
    'status', 
    'actions'
  ]

  const actions = [
    { 
      name: "View", 
      tooltip: "view",
      icon: <VisibilityIcon fontSize="small" />,
      className: "bg-sky-500 hover:bg-sky-600",
      function: viewHandleClick,
      visible: true,
    },
    { 
      name: "Edit", 
      tooltip: "edit",
      icon: <EditIcon fontSize="small" />,
      className: "bg-green-500 hover:bg-green-600",
      function: editHandleClick,
      visible: false,
    },
    { 
      name: "View Expense Account", 
      tooltip: "view",
      icon: <ListAltIcon fontSize="small" />,
      className: "bg-sky-500 hover:bg-sky-600",
      function: viewExpenseAccountHandleClick,
      visible: false,
    },
    { 
      name: "View Paid Through Account", 
      tooltip: "view",
      icon: <ListAltIcon fontSize="small" />,
      className: "bg-sky-500 hover:bg-sky-600",
      function: viewPaidThroughAccountHandleClick,
      visible: false,
    },
    { 
      name: "Post", 
      tooltip: "post",
      icon: <PostAddIcon fontSize="small" />,
      className: "bg-orange-500 hover:bg-orange-600",
      function: postHandleClick,
      visible: true,
    },
    { 
      name: "Void", 
      tooltip: "void",
      icon: <NotInterestedIcon fontSize="small" />,
      className: "bg-red-500 hover:bg-red-600",
      function: voidHandleClick,
      visible: true,
    },
  ];

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);

      const response = await axios.get(`${apiUrl}/api/Expense/vendor/${vendorFilter?.vendorId ?? "All"}/customer/${customerFilter?.customerId ?? "All"}/status/${statusFilter ? statusFilter : "All"}` , {
        headers: { 'Content-Type': 'application/json'}
      })
        
      setData(response.data)
      setFilteredData(response.data)
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  }, [vendorFilter, customerFilter, statusFilter]);

  useEffect(() => {
    if(active){
      fetchData();
    }
  }, [active, fetchData])
//#endregion










//#region Access Template
  const accountData = JSON.parse(localStorage.getItem("accountData"));
  
  if (!accountData?.accessTemplate?.hasPayables) {
    return <NoAccess />;
  }
//#endregion


  return (
    <>
      <div className="py-6 bg-gray-50 min-h-screen">
        {/* Header Section */}
        <div className="flex flex-col md:flex-row md:items-center justify-between mb-8 gap-4">
          {/* Search and Filters */}
          <div className="flex justify-between items-center gap-2 w-full">
            <div className="w-full">
              <input
                type="text"
                placeholder="Search account..."
                className="px-4 py-2 border rounded-lg w-full md:w-2/3 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color"
                value={search}
                onChange={(e) => handleSearch(e.target.value)}
              />
              {/* Add filter dropdowns here if needed */}
            </div>
          </div>
          <div className="flex gap-3 w-full justify-start md:justify-end">
            <button className="bg-white border border-gray-300 text-theme-color hover:bg-gray-100 px-3 py-1 rounded-md flex items-center gap-2 hover:bg-opacity-90 transition"
              onClick={openFilterForm}
            >
              <FilterAltIcon/> Filter
            </button>
            <button onClick={addHandleClick} className="flex items-center gap-2 bg-theme-color text-white px-4 py-2 rounded-lg text-sm font-semibold hover:bg-theme-color-h transition shadow-md">
              <AddCircleOutlineIcon fontSize="small" /> New Expense
            </button>
          </div>
        </div>

        <CreateTable
          tableName={"Expense"}
          headers={headers}
          accessors={accessors}
          data={data}
          actions={actions}

          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          itemsPerPage={10}
          totalItems={data?.length}
        />
      </div>

      <AddUpdateModal 
        visible={showAddForm}
        onClose={closeAddForm}
        onSave={handleAddData}
        modalName={"Add Expense"}

        data={data}
        expenseAccounts={expenseAccounts} setExpenseAccounts={setExpenseAccounts}
        paidThroughAccount={paidThroughAccount} setPaidThroughAccount={setPaidThroughAccount}
        paidAmount={paidAmount} setPaidAmount={setPaidAmount}
        vendor={vendor} setVendor={setVendor}
        customer={customer} setCustomer={setCustomer}
        expenseNumber={expenseNumber} setExpenseNumber={setExpenseNumber}
        referenceNumber={referenceNumber} setReferenceNumber={setReferenceNumber}
        notes={notes} setNotes={setNotes}
        expenseDate={expenseDate} setExpenseDate={setExpenseDate}
        uploadedFile={uploadedFile} setUploadedFile={setUploadedFile}
        vat={vat} setVAT={setVAT}
        discounts={discounts} setDiscounts={setDiscounts}
        zeroRated={zeroRated} setZeroRated={setZeroRated}
        ewt={ewt} setEWT={setEWT}
        subTotal={subTotal} setSubTotal={setSubTotal}
        totalAmount={totalAmount} setTotalAmount={setTotalAmount}

        paymentMethod={paymentMethod} setPaymentMethod={setPaymentMethod}
        bank={bank} setBank={setBank}
        checkbook={checkbook} setCheckbook={setCheckbook}
        selectedData={selectedData}

        isEditable={true}
      />

      <AddUpdateModal 
        visible={showUpdateForm}
        onClose={closeUpdateForm}
        onSave={handleUpdateData}
        modalName={"Update Expense"}

        data={data}
        expenseAccounts={expenseAccounts} setExpenseAccounts={setExpenseAccounts}
        paidThroughAccount={paidThroughAccount} setPaidThroughAccount={setPaidThroughAccount}
        paidAmount={paidAmount} setPaidAmount={setPaidAmount}
        vendor={vendor} setVendor={setVendor}
        customer={customer} setCustomer={setCustomer}
        expenseNumber={expenseNumber} setExpenseNumber={setExpenseNumber}
        referenceNumber={referenceNumber} setReferenceNumber={setReferenceNumber}
        notes={notes} setNotes={setNotes}
        expenseDate={expenseDate} setExpenseDate={setExpenseDate}
        uploadedFile={uploadedFile} setUploadedFile={setUploadedFile}
        vat={vat} setVAT={setVAT}
        discounts={discounts} setDiscounts={setDiscounts}
        zeroRated={zeroRated} setZeroRated={setZeroRated}
        ewt={ewt} setEWT={setEWT}
        subTotal={subTotal} setSubTotal={setSubTotal}
        totalAmount={totalAmount} setTotalAmount={setTotalAmount}

        paymentMethod={paymentMethod} setPaymentMethod={setPaymentMethod}
        bank={bank} setBank={setBank}
        checkbook={checkbook} setCheckbook={setCheckbook}
        selectedData={selectedData}

        isEditable={true}
      />

      <ViewModal 
        visible={showViewForm}
        onClose={closeViewForm}
        // onSave={handleUpdateData}
        modalName={"View Expense"}

        data={data}
        expenseAccounts={expenseAccounts} setExpenseAccounts={setExpenseAccounts}
        paidThroughAccount={paidThroughAccount} setPaidThroughAccount={setPaidThroughAccount}
        paidAmount={paidAmount} setPaidAmount={setPaidAmount}
        vendor={vendor} setVendor={setVendor}
        customer={customer} setCustomer={setCustomer}
        expenseNumber={expenseNumber} setExpenseNumber={setExpenseNumber}
        referenceNumber={referenceNumber} setReferenceNumber={setReferenceNumber}
        notes={notes} setNotes={setNotes}
        expenseDate={expenseDate} setExpenseDate={setExpenseDate}
        uploadedFile={uploadedFile} setUploadedFile={setUploadedFile}
        vat={vat} setVAT={setVAT}
        discounts={discounts} setDiscounts={setDiscounts}
        zeroRated={zeroRated} setZeroRated={setZeroRated}
        ewt={ewt} setEWT={setEWT}
        subTotal={subTotal} setSubTotal={setSubTotal}
        totalAmount={totalAmount} setTotalAmount={setTotalAmount}

        paymentMethod={paymentMethod} setPaymentMethod={setPaymentMethod}
        bank={bank} setBank={setBank}
        checkbook={checkbook} setCheckbook={setCheckbook}
        selectedData={selectedData}

        isEditable={false}
      />

      <ViewExpenseAccountModal 
        visible={showViewExpenseAccountForm}
        onClose={closeViewExpenseAccountForm}
        // onSave={handleUpdateData}
        modalName={"View Expense Accounts"}

        expenseAccounts={selectedExpenseAccount} setExpenseAccounts={setSelectedExpenseAccount}
      />

      <ViewPaidThroughAccountModal 
        visible={showViewPaidThroughAccountForm}
        onClose={closeViewPaidThroughAccountForm}
        // onSave={handleUpdateData}
        modalName={"View Paid Through Accounts"}

        paidThroughAccounts={selectedPaidThroughAccount} setPaidThroughAccounts={setSelectedPaidThroughAccount}
      />

      <CreateJournalModal 
        visible={showPostForm}
        onClose={closePostForm}
        // onSave={handleUpdateData}
        modalName={"Create Journal"}
        isEditable={true}
        data={selectedData}
        fetchData={fetchData}
        status={"Posted"}
      />

      <ConfirmationModal 
        visible={showVoidForm} 
        onClose={closeVoidForm} 
        onSave={handleVoidStatus} 
        modalName={"Void"} 
        message={`Do you want to void this [ ${selectedData?.expenseNumber || ""} ]?.`}
      />

      <FilterModal 
        visible={showFilterForm}
        onClose={closeFilterForm}
        modalName={"Filter"}

        customerFilter={customerFilter} setCustomerFilter={setCustomerFilter}
        vendorFilter={vendorFilter} setVendorFilter={setVendorFilter}
        statusFilter={statusFilter} setStatusFilter={setStatusFilter}
      />

      <div className="fixed top-5 right-5 z-50 flex flex-col space-y-2">
        <SuccessMessage message={successMessage} onClose={() => setSuccessMessage("")} />
        <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
      </div>

      { loading && <Loading />}
    </>
  );
}









//#region AddUpdate/View Modal
const AddUpdateModal = ({
  visible, onClose, onSave, modalName,
  expenseAccounts, setExpenseAccounts,
  paidThroughAccount, setPaidThroughAccount,
  paidAmount, setPaidAmount,
  vendor, setVendor,
  customer, setCustomer,
  expenseNumber, setExpenseNumber,
  referenceNumber, setReferenceNumber,
  notes, setNotes,
  expenseDate, setExpenseDate,
  uploadedFile, setUploadedFile,
  vat, setVAT,
  discounts, setDiscounts,
  zeroRated, setZeroRated,
  ewt, setEWT,
  subTotal, setSubTotal,
  totalAmount, setTotalAmount,

  paymentMethod, setPaymentMethod,
  bank, setBank,
  checkbook, setCheckbook,

  selectedData,
  isEditable
}) => {
  const getCurrency = JSON.parse(localStorage.getItem("currency") || "{}");
  const [failMessage, setFailMessage] = useState("");
  const [showExpenses, setShowExpenses] = useState(true);
  // const [totalExpenseAmount, setTotalExpenseAmount] = useState(0);

//#region Adjustments
  const [vatAmount, setVATAmount] = useState(0);
  const [discountAmount, setDiscountAmount] = useState(0);
  const [zeroRatedAmount, setZeroRatedAmount] = useState(0);
  const [ewtAmount, setEWTAmount] = useState(0);

  /* useEffect(() => {
    if (subTotal > 0) {
      // VAT
      const _vatPercent = vat / 100;

      // Discount
      const _discountPercent = discounts / 100;
      const _discountAmount = subTotal * _discountPercent;

      // Zero Rated
      const _zeroRatedPercent = zeroRated / 100;
      const _zeroRatedAmount = subTotal * _zeroRatedPercent;

      // VAT adjusted for Zero-Rated
      const _vatAmount = (subTotal - _discountAmount - _zeroRatedAmount) * _vatPercent;

      // EWT
      const _ewtPercent = ewt / 100;
      const _ewtAmount = (subTotal - _discountAmount) * _ewtPercent;

      // Set state
      setDiscountAmount(_discountAmount);
      setZeroRatedAmount(_zeroRatedAmount);
      setVATAmount(_vatAmount);
      setEWTAmount(_ewtAmount);

      // Compute total using freshly computed values
      const _totalAmount = subTotal - _discountAmount + _vatAmount - _ewtAmount;
      setTotalAmount(_totalAmount);
      setPaidAmount(_totalAmount);
    }
  }, [setTotalAmount, setPaidAmount, subTotal, vat, discounts, zeroRated, ewt]); */

  const resetLocalVariables = () => {
    setFailMessage("")
    setVATAmount(0);
    setDiscountAmount(0);
    setZeroRatedAmount(0);
    setEWTAmount(0);
  }
//#endregion








//#region Vendor
  const [showVendorSelectForm, setShowVendorSelectForm] = useState(false);
  const openVendorSelectForm = () => {
    setShowVendorSelectForm(true);
  }
  const closeVendorSelectForm = () => {
    setShowVendorSelectForm(false);
  }
//#endregion








//#region PaidThrough
  const [showPaidThroughAccountSelectForm, setShowPaidThroughAccountSelectForm] = useState(false);
  const openPaidThroughAccountSelectForm = () => {
    setShowPaidThroughAccountSelectForm(true);
  }
  const closePaidThroughAccountSelectForm = () => {
    setShowPaidThroughAccountSelectForm(false);
  }
//#endregion










//#region Customer
  const [showCustomerSelectForm, setShowCustomerSelectForm] = useState(false);
  const openCustomerSelectForm = () => {
    setShowCustomerSelectForm(true);
  }
  const closeCustomerSelectForm = () => {
    setShowCustomerSelectForm(false);
  }
//#endregion






//#region Bank
  const [showBankSelectForm, setShowBankSelectForm] = useState(false);
  const openBankSelectForm = () => {
    setShowBankSelectForm(true);
  }
  const closeBankSelectForm = () => {
    setShowBankSelectForm(false);
  }
//#endregion






  const handleSubmit = async () => {
    // Logic updated to match your state requirements
    if (expenseAccounts.length <= 0 || !paidThroughAccount) {
      setFailMessage("Please fill up all required fields (Expense Account, Paid Through).");
      return;
    }
    await onSave();
    closeModal();
  };

  const closeModal = () => {
    setFailMessage("");
    resetLocalVariables();
    onClose();
    closeBankSelectForm();
  };









//#region ExpenseAccount
  const [currentPageExpenseAccount, setCurrentPageExpenseAccount] = useState(1);

  const headersExpenseAccount = [
    'ACCOUNT', 
    'SUBTOTAL', 
    // 'TAX TYPE', 
    // 'TAX CODE', 
    'ADJUSTMENTS', 
    'TOTAL AMOUNT', 
    ...(isEditable ? ['ACTIONS'] : [])
  ]
  const accessorsExpenseAccount = [
    'expenseAccountName', 
    'amount', 
    // 'amountTaxType', 
    // 'taxationCodeDescription',
    'adjustments',
    'totalAmount', 
    ...(isEditable ? ['actions'] : [])
  ]

  const [showAddExpenseAccountForm, setShowAddExpenseAccountForm] = useState(false);
  const [selectedExpenseAccount, setSelectedExpenseAccount] = useState(null);
  const openAddExpenseAccountForm = () => {
    setShowAddExpenseAccountForm(true);
  }
  const closeAddExpenseAccountForm = () => {
    setShowAddExpenseAccountForm(false);
    setSelectedExpenseAccount(null)
  }

  const [showUpdateExpenseAccountForm, setShowUpdateExpenseAccountForm] = useState(false);
  const openUpdateExpenseAccountForm = () => {
    setShowUpdateExpenseAccountForm(true);
  }
  const closeUpdateExpenseAccountForm = () => {
    setShowUpdateExpenseAccountForm(false);
    setSelectedExpenseAccount(null)
  }

  const editHandleExpenseAccountClick = (_data) => {
    setSelectedExpenseAccount(_data)
    openUpdateExpenseAccountForm();
  }

  const [showDeleteExpenseAccountForm, setShowDeleteExpenseAccountForm] = useState(false);
  const openDeleteExpenseAccountForm = () => {
    setShowDeleteExpenseAccountForm(true);
  }
  const closeDeleteExpenseAccountForm = () => {
    setShowDeleteExpenseAccountForm(false);
    setSelectedExpenseAccount(null)
  }

  const deleteHandleExpenseAccountClick = (_data) => {
    setSelectedExpenseAccount(_data)
    openDeleteExpenseAccountForm();
  }

  const handleDeleteExpenseAccount = () => {
    setExpenseAccounts(prev =>
      prev.filter(
        item => item.expenseAccountId !== selectedExpenseAccount?.expenseAccountId
      )
    );
  };

  const actionsExpenseAccount = [
    { 
      name: "Edit", 
      tooltip: "edit",
      icon: <EditIcon fontSize="small" />,
      className: "bg-green-500 hover:bg-green-600",
      function: editHandleExpenseAccountClick,
      visible: true,
    },
    { 
      name: "Delete", 
      tooltip: "delete",
      icon: <DeleteForeverIcon fontSize="small" />,
      className: "bg-red-500 hover:bg-red-600",
      function: deleteHandleExpenseAccountClick,
      visible: true,
    },
  ];

  useEffect(() => {
    if(visible){
      const _totalExpenseAmount = expenseAccounts?.reduce((acc, item) => acc + (Number(item.totalAmount) || 0), 0) || 0;
      setTotalAmount(_totalExpenseAmount)
      setPaidAmount(_totalExpenseAmount)
      setSubTotal(_totalExpenseAmount)
    }
  }, [visible, expenseAccounts, setPaidAmount, setSubTotal, setTotalAmount])
//#endregion 





  const handleFileChange = async (e) => {
    const fileData = await HandleFileUpload(e);

    if (fileData) {
      setUploadedFile(fileData);
    }
  };






  if (!visible) return null;

  return (
    <>
      <AnimatePresence>
        <motion.div
          // initial={{ opacity: 0 }}
          // animate={{ opacity: 1 }}
          // exit={{ opacity: 0 }}
          className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm flex items-center justify-center z-50 p-4"
        >
          <motion.div
            initial={{ scale: 0.95, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.95, opacity: 0, y: 20 }}
            className="bg-gray-100 rounded-2xl shadow-2xl w-full max-w-7xl overflow-hidden flex flex-col max-h-[90vh]"
          >
            {/* Header */}
            <div className="px-8 py-5 bg-white border-b border-gray-200 flex justify-between items-center">
              <div>
                <h2 className="text-2xl font-bold text-gray-800 tracking-tight">{modalName}</h2>
                <p className="text-sm text-gray-500">Enter the transaction details below</p>
              </div>
              <button onClick={closeModal} className="text-gray-400 hover:text-gray-600 transition p-2 hover:bg-gray-100 rounded-full">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            {/* Body */}
            <div className="p-8 overflow-y-auto custom-scrollbar">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <>
                  {/* --- Section 1: Entities --- */}
                  <div className="space-y-4 md:col-span-2 mt-2">
                    <h3 className="text-xs font-bold uppercase tracking-wider text-gray-400 border-b pb-1">Related Parties</h3>
                  </div>

                  {isEditable ?
                    <div>
                      <label className="block text-sm font-semibold mb-1 text-gray-700">
                        Vendor
                      </label>
                      <div className="flex flex-row items-center">
                        <input
                          type="text"
                          placeholder="Select Vendor"
                          className="w-full border border-gray-300 text-sm rounded-l-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                          value={`${vendor ? `${vendor?.vendorId} - ${vendor?.name1}` : ""}`}
                          readOnly
                        />
                        {!vendor ?
                          <button className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg" onClick={openVendorSelectForm}>
                            <PersonSearchIcon className="text-white"/>
                          </button> 
                          :
                          <button className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg" onClick={()=>setVendor(null)}>
                            <RemoveCircleIcon className="text-white"/>
                          </button>
                        }
                      </div>
                    </div>
                  :
                    <div>
                      <label className="block text-sm font-semibold mb-1 text-gray-700">
                        Vendor
                      </label>
                      <div className="flex flex-row items-center">
                        <input
                          type="text"
                          placeholder="Select Vendor"
                          className="w-full border border-gray-300 text-sm rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                          value={`${vendor ? `${vendor?.vendorId} - ${vendor?.name1}` : ""}`}
                          readOnly
                        />
                      </div>
                    </div>
                  }

                  {isEditable ?
                    <div className="hidden">
                      <label className="block text-sm font-semibold mb-1 text-gray-700">
                        Customer
                      </label>
                      <div className="flex flex-row items-center">
                        <input
                          type="text"
                          placeholder="Select Customer"
                          className="w-full border border-gray-300 text-sm rounded-l-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                          value={`${customer ? `${customer?.customerId} - ${customer?.name1}` : ""}`}
                          readOnly
                        />
                        {!customer ?
                          <button className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg" onClick={openCustomerSelectForm}>
                            <PersonSearchIcon className="text-white"/>
                          </button> 
                          :
                          <button className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg" onClick={()=>setCustomer(null)}>
                            <RemoveCircleIcon className="text-white"/>
                          </button>
                        }
                      </div>
                    </div>
                  :
                    <div>
                      <label className="block text-sm font-semibold mb-1 text-gray-700">
                        Customer
                      </label>
                      <div className="flex flex-row items-center">
                        <input
                          type="text"
                          placeholder="Select Customer"
                          className="w-full border border-gray-300 text-sm rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                          value={`${customer ? `${customer?.customerId} - ${customer?.name1}` : ""}`}
                          readOnly
                        />
                      </div>
                    </div>
                  }
                  <div>

                  </div>

                  <div>
                    <label className="block text-sm font-semibold mb-1 text-gray-700">
                      Expense Number <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="e.g. EXPENSE-2023-001"
                      className="text-sm w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color transition"
                      value={expenseNumber}
                      onChange={(e) => setExpenseNumber(e.target.value)}
                      readOnly
                    />
                  </div>
                  <div className="hidden">
                    <label className="block text-sm font-semibold mb-1 text-gray-700">
                      Reference Number
                    </label>
                    <input
                      type="text"
                      placeholder="e.g. INV-2023-001"
                      className="text-sm w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color transition"
                      value={referenceNumber}
                      onChange={(e) => setReferenceNumber(e.target.value)}
                      readOnly={!isEditable}
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-semibold mb-1 text-gray-700">
                      Expense Date
                    </label>
                    <DateSelect data={expenseDate} setData={setExpenseDate} isEditable={isEditable}/>
                  </div>
                </>

                {/* --- Section 2: Expenses Account (Expandable) --- */}
                <div className="md:col-span-2 mt-4">
                  {/* Toggle Header Button */}
                  <button
                    type="button"
                    onClick={() => setShowExpenses(!showExpenses)}
                    className="flex items-center justify-between w-full border-b pb-2 group hover:border-theme-color transition-colors"
                  >
                    <div className="flex items-center gap-2">
                      <h3 className={`text-xs font-bold uppercase tracking-wider transition-colors ${showExpenses ? 'text-theme-color' : 'text-gray-400'}`}>
                        Expenses Account
                      </h3>
                      {/* Badge showing count */}
                      {expenseAccounts?.length > 0 && (
                        <span className="bg-gray-200 text-gray-600 text-[10px] px-2 py-0.5 rounded-full font-bold">
                          {expenseAccounts.length}
                        </span>
                      )}
                    </div>
                    
                    <div className={`transform transition-transform duration-300 text-gray-400 group-hover:text-theme-color ${showExpenses ? "rotate-180" : ""}`}>
                      <ExpandMoreIcon /> 
                    </div>
                  </button>

                  {/* Expandable Content Area */}
                  <AnimatePresence>
                    {showExpenses && (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.3, ease: "easeInOut" }}
                        className="overflow-hidden"
                      >
                        <div className="py-5 space-y-5">
                          {/* Add button */}
                          <div className="flex gap-3 w-full justify-start">
                            {isEditable &&
                              <button 
                                type="button"
                                onClick={openAddExpenseAccountForm} 
                                className="flex items-center gap-2 bg-theme-color text-white px-5 py-2 rounded-lg text-sm font-semibold hover:bg-theme-color-h transition shadow-md active:scale-95"
                              >
                                <AddCircleOutlineIcon fontSize="small" /> 
                                New Account
                              </button>
                            }
                          </div>

                          {/* List of Expenses Account */}
                          <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
                            <CreateTable
                              tableName={"Expense Accounts"}
                              headers={headersExpenseAccount}
                              accessors={accessorsExpenseAccount}
                              data={expenseAccounts}
                              actions={actionsExpenseAccount}
                              currentPage={currentPageExpenseAccount}
                              setCurrentPage={setCurrentPageExpenseAccount}
                              itemsPerPage={10}
                              totalItems={expenseAccounts?.length}
                            />
                          </div>
                        </div>
                      </motion.div>
                    )}
                  </AnimatePresence>

                  {/* Summary when collapsed (Optional) */}
                  {!showExpenses && expenseAccounts?.length > 0 && (
                    <motion.p 
                      // initial={{ opacity: 0 }} 
                      // animate={{ opacity: 1 }} 
                      className="text-[11px] text-gray-400 mt-2 italic"
                    >
                      Click to view {expenseAccounts.length} expense line items...
                    </motion.p>
                  )}
                </div>

                {/* ADjustments */}
                <div className="hidden">
                  <div className="space-y-4 md:col-span-2 mt-2">
                    <h3 className="text-xs font-bold uppercase tracking-wider text-gray-400 border-b pb-1">Adjustments</h3>
                  </div>

                  <div>
                    <label className="block text-sm font-semibold mb-1 text-gray-700">
                      VAT (%)
                    </label>
                    <input
                      type="number"
                      placeholder="0"
                      className="text-sm w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color transition"
                      value={vat}
                      onChange={(e) => setVAT(e.target.value)}
                      readOnly={!isEditable}
                    />
                    <div className="mt-2 flex items-center gap-2 bg-amber-50 border border-amber-200 text-amber-700 px-4 py-2 rounded-lg text-sm font-medium">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-amber-500" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                      </svg>
                      {`${FormatValueToDecimal(vat || 0)} % - (${getCurrency?.symbol ?? ""} ${FormatValueToDecimal(vatAmount || 0)})`}
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-semibold mb-1 text-gray-700">
                      Discounts (%)
                    </label>
                    <input
                      type="number"
                      placeholder="0"
                      className="text-sm w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color transition"
                      value={discounts}
                      onChange={(e) => setDiscounts(e.target.value)}
                      readOnly={!isEditable}
                    />
                    <div className="mt-2 flex items-center gap-2 bg-amber-50 border border-amber-200 text-amber-700 px-4 py-2 rounded-lg text-sm font-medium">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-amber-500" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                      </svg>
                      {`${FormatValueToDecimal(discounts || 0)} % - (${getCurrency?.symbol ?? ""} ${FormatValueToDecimal(discountAmount || 0)})`}
                    </div>
                  </div>

                  <div className="hidden">
                    <label className="block text-sm font-semibold mb-1 text-gray-700">
                      Zero Rated (%)
                    </label>
                    <input
                      type="number"
                      placeholder="0"
                      className="text-sm w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color transition"
                      value={zeroRated}
                      onChange={(e) => setZeroRated(e.target.value)}
                      readOnly={!isEditable}
                    />
                    <div className="mt-2 flex items-center gap-2 bg-amber-50 border border-amber-200 text-amber-700 px-4 py-2 rounded-lg text-sm font-medium">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-amber-500" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                      </svg>
                      {`${FormatValueToDecimal(zeroRated || 0)} % - (${getCurrency?.symbol ?? ""} ${FormatValueToDecimal(zeroRatedAmount || 0)})`}
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-semibold mb-1 text-gray-700">
                      EWT (%)
                    </label>
                    <input
                      type="number"
                      placeholder="0"
                      className="text-sm w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color transition"
                      value={ewt}
                      onChange={(e) => setEWT(e.target.value)}
                      readOnly={!isEditable}
                    />
                    <div className="mt-2 flex items-center gap-2 bg-amber-50 border border-amber-200 text-amber-700 px-4 py-2 rounded-lg text-sm font-medium">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-amber-500" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                      </svg>
                      {`${FormatValueToDecimal(ewt || 0)} % - (${getCurrency?.symbol ?? ""} ${FormatValueToDecimal(ewtAmount || 0)})`}
                    </div>
                  </div>
                </div>

                {/* --- Section 3: Final Summary --- */}
                <div className="md:col-span-2">
                  <div className="bg-white border border-gray-200 rounded-2xl p-6 shadow-sm flex flex-col md:flex-row justify-between items-center gap-4">
                    <div className="flex items-center gap-4">
                      <div className="bg-theme-color/10 p-3 rounded-xl">
                        <AccountBalanceWalletIcon className="text-theme-color" />
                      </div>
                      <div>
                        <p className="text-[11px] font-bold uppercase tracking-widest text-gray-400">
                          Total Transaction Amount
                        </p>
                        <p className="text-xs text-gray-500">
                          Sum of all expense line items above
                        </p>
                      </div>
                    </div>

                    <div className="text-center md:text-right">
                      <div className="flex items-baseline justify-center md:justify-end gap-2">
                        <span className="text-3xl font-black text-gray-800 tracking-tight">
                          {`${getCurrency?.symbol ? getCurrency?.symbol : ""} ${FormatValueToDecimal(totalAmount)}`}
                        </span>
                      </div>
                      {/* Visual indicator of validation */}
                      {totalAmount > 0 ? (
                        <span className="text-[10px] font-bold text-green-500 bg-green-50 px-2 py-0.5 rounded-full uppercase tracking-tighter">
                          ● Ready to Save
                        </span>
                      ) : (
                        <span className="text-[10px] font-bold text-amber-500 bg-amber-50 px-2 py-0.5 rounded-full uppercase tracking-tighter">
                          ○ No amount detected
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                
                <>
                  <div className="space-y-4 md:col-span-2 mt-2">
                    <h3 className="text-xs font-bold uppercase tracking-wider text-gray-400 border-b pb-1">Payment</h3>
                  </div>

                  <div>
                    <label className="block text-sm font-semibold mb-1 text-gray-700">
                      (Cr) Paid Through Account <span className="text-red-500">*</span>
                    </label>
                    <div className="flex flex-row items-center">
                      <input
                        type="text"
                        placeholder="Select Account"
                        className="w-full border border-gray-300 text-sm rounded-l-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                        value={paidThroughAccount?.accountName || ""}
                        readOnly
                      />
                      {!paidThroughAccount ?
                        <button className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg" onClick={openPaidThroughAccountSelectForm}>
                          <ManageSearchIcon className="text-white"/>
                        </button> 
                        :
                        <button className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg" onClick={()=>setPaidThroughAccount(null)}>
                          <RemoveCircleIcon className="text-white"/>
                        </button>
                      }
                    </div>
                  </div>

                  <div className="hidden">
                    <label className="block text-sm font-semibold mb-1 text-gray-700">
                      Paid Amount
                    </label>
                    <input
                      type="number"
                      className="text-sm w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color transition"
                      value={paidAmount}
                      onChange={(e) => setPaidAmount(e.target.value)}
                    />
                    <div className="text-xs text-gray-500 flex items-center gap-1">
                      <span className="font-semibold text-gray-400 italic">
                        {getCurrency?.symbol ?? ""}
                        {FormatValueToDecimal(paidAmount || 0)}
                      </span>
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-semibold mb-1 text-gray-700">
                      Payment Method <span className="text-red-500">*</span>
                    </label>
                    <PaymentMethodSelect2 data={paymentMethod} setData={setPaymentMethod} bank={bank} setBank={setBank} 
                      referenceNumber={referenceNumber} setReferenceNumber={setReferenceNumber}
                      isEditable={true} 
                    />
                  </div>
                  
                  {paymentMethod?.id === CHECK_PAYMENT_METHOD && 
                    <>
                      <div>
                        <label className="block text-sm font-semibold mb-1 text-gray-700">
                          Bank <span className="text-red-500">*</span>
                        </label>
                        <div className="flex flex-row items-center">
                          <input
                            type="text"
                            placeholder="Select Bank"
                            className="w-full border border-gray-300 text-sm rounded-l-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                            value={bank?.bankName || ""}
                            readOnly
                          />
                          {!bank ?
                            <button className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg" onClick={openBankSelectForm}>
                              <ManageSearchIcon className="text-white"/>
                            </button> 
                            :
                            <button className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg" onClick={()=>setBank(null)}>
                              <RemoveCircleIcon className="text-white"/>
                            </button>
                          }
                        </div>
                      </div>
                      <div>
                        <label className="block text-sm font-semibold mb-1 text-gray-700">
                          Checkbook <span className="text-red-500">*</span>
                        </label>
                        { selectedData != null ?
                          <CheckbookFromUpdateSelect oldData={selectedData} data={checkbook} setData={setCheckbook} bank={bank} 
                            referenceNumber={referenceNumber} setReferenceNumber={setReferenceNumber}
                            isEditable={true} 
                          />
                          :
                          <CheckbookSelect data={checkbook} setData={setCheckbook} bank={bank} 
                            referenceNumber={referenceNumber} setReferenceNumber={setReferenceNumber}
                            isEditable={true} 
                          />
                        }
                      </div>
                    </>
                  }

                  <div>
                    <label className="block text-sm font-semibold mb-1 text-gray-700">
                      Reference No <span className="text-red-500">*</span>
                    </label>
                    <input
                      placeholder="0000-0000"
                      className="text-sm w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color transition"
                      value={referenceNumber}
                      onChange={(e) => setReferenceNumber(e.target.value)}
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-semibold mb-1 text-gray-700">Amount</label>
                    <input
                      type="number"
                      placeholder="0.00"
                      className="text-sm w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color transition"
                      value={paidAmount}
                      onChange={(e) => setPaidAmount(e.target.value)}
                    />
                    <div className="text-xs text-gray-500 flex items-center gap-1">
                      <span className="font-semibold text-gray-400 italic">
                        {getCurrency?.symbol ?? ""}
                        {FormatValueToDecimal(paidAmount || 0)}
                      </span>
                    </div>
                  </div>
                </>

                {/* Full Width: Notes */}
                <div className="md:col-span-2">
                  <label className="block text-sm font-semibold mb-1 text-gray-700">
                    Notes
                  </label>
                  <textarea
                    rows="3"
                    placeholder="Enter any additional details or remarks..."
                    className="text-sm w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color transition"
                    value={notes}
                    onChange={(e) => setNotes(e.target.value)}
                    readOnly={!isEditable}
                  />
                </div>
              </div>

              <div className="mt-6 space-y-2">
                <label className="text-[11px] font-bold uppercase tracking-widest text-gray-400 ml-1">Attachment</label>
                
                <div className={`relative group transition-all duration-200 rounded-xl border-2 border-dashed 
                  ${uploadedFile ? 'border-theme-color/30 bg-theme-color/5' : 'border-gray-200 hover:border-theme-color/50 bg-gray-50/50 hover:bg-white'}`}>
                  
                  {/* Hidden Input - clickable over the whole area */}
                  {isEditable && (
                    <input
                      type="file"
                      onChange={handleFileChange}
                      className="absolute inset-0 w-full h-full opacity-0 cursor-pointer z-10"
                    />
                  )}

                  <div className="p-4 flex items-center justify-between gap-4">
                    <div className="flex items-center gap-3">
                      {/* Icon based on state */}
                      <div className={`p-2.5 rounded-lg ${uploadedFile ? 'bg-theme-color text-white' : 'bg-gray-200 text-gray-500'}`}>
                        {uploadedFile ? (
                          <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                          </svg>
                        ) : (
                          <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                          </svg>
                        )}
                      </div>

                      <div>
                        <p className={`text-sm font-semibold truncate max-w-[200px] ${uploadedFile ? 'text-gray-800' : 'text-gray-500'}`}>
                          {uploadedFile ? uploadedFile.fileName : "Click to upload file"}
                        </p>
                        <p className="text-[11px] text-gray-400 font-medium">
                          {uploadedFile ? (uploadedFile.contentType || "Document") : "Support any file format"}
                        </p>
                      </div>
                    </div>

                    {/* Action Button */}
                    {uploadedFile && (
                      <button
                        type="button"
                        onClick={(e) => { e.stopPropagation(); DownloadFile(uploadedFile); }}
                        className="relative z-20 flex items-center gap-2 px-4 py-2 text-xs font-bold text-theme-color bg-white border border-theme-color/20 rounded-lg shadow-sm hover:bg-theme-color hover:text-white transition-all"
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                        </svg>
                        DOWNLOAD
                      </button>
                    )}
                  </div>
                </div>
                
                {!uploadedFile && <p className="text-[10px] text-gray-400 italic ml-1">* No file attached yet</p>}
              </div>
            </div>

            {/* Footer */}
            <div className="px-8 py-6 border-t bg-white flex justify-end items-center space-x-4">
              <button
                onClick={closeModal}
                className="px-6 py-2.5 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-50 transition font-semibold text-sm"
              >
                Cancel
              </button>
              { isEditable &&
                <button
                  onClick={handleSubmit}
                  className="px-10 py-2.5 rounded-lg bg-theme-color text-white font-bold hover:opacity-90 shadow-lg shadow-theme-color/20 transition active:scale-95 text-sm"
                >
                  Save Transaction
                </button>
              }
            </div>
          </motion.div>
        </motion.div>
      </AnimatePresence>
      
      <VendorSelect 
        visible={showVendorSelectForm} 
        onClose={closeVendorSelectForm}
        modalName={"Select Vendor"}
        data={vendor} setData={setVendor}
      />
      
      <CustomerSelect 
        visible={showCustomerSelectForm} 
        onClose={closeCustomerSelectForm}
        modalName={"Select Customer"}
        data={customer} setData={setCustomer}
      />

      <AddUpdateExpenseAccountModal 
        visible={showAddExpenseAccountForm} 
        onClose={closeAddExpenseAccountForm}
        modalName={"Add Expense Account"}
        data={selectedExpenseAccount}
        expenseAccounts={expenseAccounts} setExpenseAccounts={setExpenseAccounts}
      />

      <AddUpdateExpenseAccountModal 
        visible={showUpdateExpenseAccountForm} 
        onClose={closeUpdateExpenseAccountForm}
        modalName={"Update Expense Account"}
        data={selectedExpenseAccount}
        expenseAccounts={expenseAccounts} setExpenseAccounts={setExpenseAccounts}
      />

      <ConfirmationModal 
        visible={showDeleteExpenseAccountForm} 
        onClose={closeDeleteExpenseAccountForm} 
        onSave={handleDeleteExpenseAccount} 
        modalName={"Delete"} 
        message={`Do you want to remove this account [ ${selectedExpenseAccount?.expenseAccountName} ]?.`}
      />
      
      <BankChartOfAccountsSelect 
        visible={showPaidThroughAccountSelectForm} 
        onClose={closePaidThroughAccountSelectForm}
        modalName={"Select Account"}
        data={paidThroughAccount} setData={setPaidThroughAccount}
      />

      <BankSelect
        visible={showBankSelectForm}
        onClose={closeBankSelectForm}
        modalName={"Select Bank"}
        data={bank} // full current data array
        setData={setBank}
      />

      <div className="fixed top-5 right-5 z-50 flex flex-col space-y-2">
        <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
      </div>
    </>
  );
};
const ViewModal = ({
  visible, onClose, onSave, modalName,
  expenseAccounts, setExpenseAccounts,
  paidThroughAccount, setPaidThroughAccount,
  paidAmount, setPaidAmount,
  vendor, setVendor,
  customer, setCustomer,
  expenseNumber, setExpenseNumber,
  expenseDate, setExpenseDate,
  referenceNumber, setReferenceNumber,
  notes, setNotes,
  vat, setVAT,
  discounts, setDiscounts,
  zeroRated, setZeroRated,
  ewt, setEWT,
  subTotal, setSubTotal,
  totalAmount, setTotalAmount,

  paymentMethod, setPaymentMethod,
  bank, setBank,
  checkbook, setCheckbook,
}) => {
  const getCurrency = JSON.parse(localStorage.getItem("currency") || "{}");
  const printRef = useRef(); // 1. Create the ref
  const [isDownloading, setIsDownloading] = useState(false);




  //#region Adjustments
  const [vatAmount, setVATAmount] = useState(0);
  const [discountAmount, setDiscountAmount] = useState(0);
  const [zeroRatedAmount, setZeroRatedAmount] = useState(0);
  const [ewtAmount, setEWTAmount] = useState(0);

  useEffect(() => {
    if (subTotal > 0) {
      // Discount
      const _discountAmount = discounts;

      // Zero Rated
      const _zeroRatedAmount = 0;

      // VAT adjusted for Zero-Rated
      const _vatAmount = vat;

      // EWT
      const _ewtAmount = ewt;

      // Set state
      setDiscountAmount(_discountAmount);
      setZeroRatedAmount(_zeroRatedAmount);
      setVATAmount(_vatAmount);
      setEWTAmount(_ewtAmount);

      // Compute total using freshly computed values
      const _totalAmount = totalAmount;
      setTotalAmount(_totalAmount);
      setPaidAmount(_totalAmount);
    }
  }, [setPaidAmount, setTotalAmount, totalAmount, subTotal, vat, discounts, zeroRated, ewt]);

  const resetLocalVariables = () => {
    setVATAmount(0);
    setDiscountAmount(0);
    setZeroRatedAmount(0);
    setEWTAmount(0);
  }
  //#endregion




  const downloadHandleClick = async () => {
    const element = printRef.current;
    if (!element) return;

    setIsDownloading(true);
    try {
      // 2. Capture the element as a canvas
      const canvas = await html2canvas(element, {
        scale: 2, // High resolution
        useCORS: true,
        logging: false,
        backgroundColor: "#ffffff", // Ensure white background
        windowWidth: 1200, 
        windowHeight: element.scrollHeight 
      });

      const imgData = canvas.toDataURL('image/png');
      
      // 3. Create PDF (A4 size)
      const pdf = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: 'a4'
      });

      const imgWidth = 210; // A4 width in mm
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
      pdf.save(`Expense_Voucher_${expenseNumber || 'Export'}.pdf`);
      
    } catch (error) {
      console.error("PDF Generation Error:", error);
    } finally {
      setIsDownloading(false);
    }
  };


  const handleSubmit = async () => {
    await downloadHandleClick();
    setIsDownloading(false)
    // closeModal();
  };

  const closeModal = () => {
    onClose();
    resetLocalVariables();
  };







  const formatVal = (num) => {
    return typeof FormatValueToDecimal === "function" 
      ? FormatValueToDecimal(num) 
      : Number(num || 0).toLocaleString(undefined, { minimumFractionDigits: 2 });
  };











  if (!visible) return null;

  return (
    <>
      <AnimatePresence>
        <motion.div
          // initial={{ opacity: 0 }}
          // animate={{ opacity: 1 }}
          // exit={{ opacity: 0 }}
          className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm flex items-center justify-center z-50 p-4"
        >
          <motion.div
            initial={{ scale: 0.95, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.95, opacity: 0, y: 20 }}
            className="bg-gray-100 rounded-2xl shadow-2xl w-full max-w-7xl overflow-hidden flex flex-col max-h-[90vh]"
          >
            {/* Header */}
            <div className="px-8 py-5 bg-white border-b border-gray-200 flex justify-between items-center">
              <div>
                <h2 className="text-2xl font-bold text-gray-800 tracking-tight">{modalName}</h2>
                <p className="text-sm text-gray-500">Summary Preview</p>
              </div>
              <button onClick={closeModal} className="text-gray-400 hover:text-gray-600 transition p-2 hover:bg-gray-100 rounded-full">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            {/* Body */}
            <div className="p-8 overflow-y-auto custom-scrollbar">
              <div ref={printRef} className="max-w-4xl mx-auto bg-white shadow-xl border border-gray-200 rounded-sm p-12 min-h-[800px] flex flex-col">
                {/* Document Header */}
                <div className="flex justify-between items-start border-b-2 border-theme-color pb-8 mb-8">
                  <div>
                    <h1 className="text-3xl font-black text-theme-color tracking-tighter mb-1">EXPENSE VOUCHER</h1>
                    <p className="text-xs font-bold text-gray-400 uppercase tracking-widest">{`Transaction Record: ${expenseNumber}`}</p>
                  </div>
                  <div className="text-right">
                    <div className="text-xs font-bold text-gray-400 uppercase tracking-wider">Reference Number</div>
                    <div className="text-lg font-mono font-bold text-gray-800">#{referenceNumber || 'N/A'}</div>
                    <div className="mt-2 text-xs font-bold text-gray-400 uppercase tracking-wider">Expense Date</div>
                    <div className="text-sm font-semibold text-gray-700">{new Date(expenseDate).toLocaleDateString()}</div>
                  </div>
                </div>

                {/* Stakeholders Section */}
                <div className="grid grid-cols-2 gap-12 mb-10">
                  <div className="space-y-2">
                    <h3 className="text-[11px] font-bold text-theme-color uppercase tracking-widest border-b border-theme-color/10 pb-1">Vendor Details</h3>
                    {vendor ? (
                      <div className="pt-1">
                        <p className="font-bold text-gray-900 text-base">{vendor.name1 || vendor.Name1}</p>
                        <p className="text-sm text-gray-500">{vendor.name2 || vendor.Name2 || 'No secondary name'}</p>
                        <p className="text-xs text-gray-400 mt-1 uppercase font-medium">ID: {vendor.vendorId || vendor.VendorId}</p>
                      </div>
                    ) : (
                      <p className="text-sm italic text-gray-400">No vendor selected</p>
                    )}
                  </div>
                  <div className="space-y-2 hidden">
                    <h3 className="text-[11px] font-bold text-theme-color uppercase tracking-widest border-b border-theme-color/10 pb-1">Customer / Project</h3>
                    {customer ? (
                      <div className="pt-1">
                        <p className="font-bold text-gray-900 text-base">{customer.name1 || customer.Name1}</p>
                        <p className="text-sm text-gray-500">{customer.name2 || customer.Name2}</p>
                        <p className="text-xs text-gray-400 mt-1 uppercase font-medium">ID: {customer.customerId || customer.CustomerId}</p>
                      </div>
                    ) : (
                      <p className="text-sm italic text-gray-400">Internal Expense / No Customer</p>
                    )}
                  </div>
                </div>

                {/* Line Items Table */}
                <div className="flex-grow">
                  <table className="w-full text-left">
                    <thead>
                      <tr className="bg-gray-50 border-y border-gray-200">
                        <th className="py-3 px-4 text-[11px] font-bold uppercase text-gray-600">Expense Account</th>
                        {/* <th className="py-3 px-4 text-[11px] font-bold uppercase text-gray-600">Taxation Code</th> */}
                        <th className="py-3 px-4 text-[11px] font-bold uppercase text-gray-600 text-right">Amount</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-100">
                      {expenseAccounts?.map((item, index) => (
                        <tr key={index} className="hover:bg-gray-50/50 transition-colors">
                          <td className="py-4 px-4">
                            <p className="text-sm font-semibold text-gray-800">{item.expenseAccountName || item.ExpenseAccountName}</p>
                          </td>
                          {/* <td className="py-4 px-4 text-sm text-gray-500 italic">
                            {item.taxationCodeDescription || item.TaxationCodeDescription || 'No Tax Applied'}
                          </td> */}
                          <td className="py-4 px-4 text-sm font-bold text-gray-900 text-right">
                            {`${getCurrency?.symbol || ""} ${FormatValueToDecimal(item.totalAmount)}`}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                {/* Totals & Payment Section */}
                <div className="mt-8 border-t-2 border-gray-100 pt-6">
                  <div className="flex justify-between items-end">
                    {/* Payment Info */}
                    <div className="space-y-4 w-full">
                      {/* Changed inline-block to block and removed tracking-tight */}
                      <div className="bg-gray-50 p-4 rounded-lg border border-gray-100 block w-full max-w-[300px]">
                        <p className="text-[10px] font-bold text-gray-400 uppercase mb-1">
                          Paid Through Account
                        </p>
                        <p className="text-sm font-bold text-gray-700 uppercase">
                          {paidThroughAccount?.accountName || "System Cash Account"}
                        </p>
                      </div>
                    </div>

                    {/* Summary Totals */}
                    <div className="space-y-2 w-full hidden">
                      <div className="flex justify-between text-sm">
                        <span className="text-gray-500 font-medium">Subtotal</span>
                        <span className="text-gray-800 font-bold">{`${getCurrency?.symbol || ""} ${FormatValueToDecimal(subTotal)}`}</span>
                      </div>
                      <div className="flex justify-between text-sm">
                        <span className="text-gray-500 font-medium">Tax Total</span>
                        <span className="text-gray-800 font-bold">0.00</span>
                      </div>
                      <div className="flex justify-between items-center pt-2 border-t border-gray-200">
                        <span className="text-base font-black text-gray-900 uppercase">Total Amount</span>
                        <span className="text-2xl font-black text-theme-color">
                          {`${getCurrency?.symbol || ""} ${FormatValueToDecimal(paidAmount)}`}
                        </span>
                      </div>
                    </div>

                    <div className="w-72 space-y-2">
                      {/* EWT Callout - Separated from the list */}
                      {ewtAmount > 0 && (
                        <div className="bg-blue-50 border border-blue-100 rounded-lg p-3 mb-4">
                          <div className="flex justify-between items-center">
                            <div className="flex flex-col">
                              <span className="text-[10px] uppercase tracking-wider text-blue-500 font-bold">
                                Withholding Tax (EWT)
                              </span>
                              <span className="text-xs text-blue-400 leading-tight">
                                Tax to be remitted
                              </span>
                            </div>
                            <span className="text-blue-700 font-bold">
                              {getCurrency?.symbol} {formatVal(ewtAmount)}
                            </span>
                          </div>
                        </div>
                      )}

                      <div className="bg-blue-50 border border-blue-100 rounded-lg p-3 mb-4">
                        <div className="flex justify-between items-center">
                          <div className="flex flex-col">
                            <span className="text-[10px] uppercase tracking-wider text-blue-500 font-bold">
                              VATABLE AMT
                            </span>
                          </div>
                          <span className="text-blue-700 font-bold">
                            {getCurrency?.symbol} {formatVal((subTotal ?? 0) - (vatAmount ?? 0))}
                          </span>
                        </div>
                        <div className="flex justify-between items-center">
                          <div className="flex flex-col">
                            <span className="text-[10px] uppercase tracking-wider text-blue-500 font-bold">
                              VAT
                            </span>
                          </div>
                          <span className="text-blue-700 font-bold">
                            {getCurrency?.symbol} {formatVal(vatAmount)}
                          </span>
                        </div>
                      </div>

                      {/* Subtotal */}
                      <div className="flex justify-between text-sm">
                        <span className="text-gray-400 font-medium">Subtotal</span>
                        <span className="text-gray-700 font-semibold">
                          {getCurrency?.symbol} {formatVal(subTotal)}
                        </span>
                      </div>

                      {/* Discount */}
                      {discountAmount > 0 && (
                        <div className="flex justify-between text-sm">
                          <span className="text-red-400 font-medium">Discount</span>
                          <span className="text-red-500 font-semibold">
                            -{getCurrency?.symbol} {formatVal(discountAmount)}
                          </span>
                        </div>
                      )}

                      {/* Zero Rated */}
                      {zeroRatedAmount > 0 && (
                        <div className="flex justify-between text-sm">
                          <span className="text-gray-400 font-medium">Zero Rated</span>
                          <span className="text-gray-600 font-semibold">
                            {getCurrency?.symbol} {formatVal(zeroRatedAmount)}
                          </span>
                        </div>
                      )}

                      <div className="border-t-2 border-gray-200 my-2"></div>

                      {/* Total Amount */}
                      <div className="flex justify-between items-center">
                        <span className="text-gray-800 font-bold">Total Amount</span>
                        <span className="text-xl text-gray-900 font-black">
                          {getCurrency?.symbol} {formatVal(paidAmount)}
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Footer Notes */}
                  {notes && (
                    <div className="mt-10 pt-6 border-t border-dashed border-gray-200">
                      <h4 className="text-[10px] font-bold text-gray-400 uppercase mb-2">Notes & Remarks</h4>
                      <p className="text-xs text-gray-600 leading-relaxed italic">
                        "{notes}"
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Footer */}
            <div className="px-8 py-6 border-t bg-white flex justify-end items-center space-x-4">
              <button
                onClick={closeModal}
                className="px-6 py-2.5 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-50 transition font-semibold text-sm"
              >
                Cancel
              </button>
              <button
                onClick={handleSubmit}
                disabled={isDownloading}
                className={`px-10 py-2.5 rounded-lg bg-theme-color text-white font-bold shadow-lg shadow-theme-color/20 transition active:scale-95 text-sm flex items-center gap-2 ${isDownloading ? 'opacity-70 cursor-not-allowed' : 'hover:opacity-90'}`}
              >
                {isDownloading ? (
                    <>
                      <svg className="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle><path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg>
                      Generating...
                    </>
                ) : 'Download PDF'}
              </button>
            </div>
          </motion.div>
        </motion.div>
      </AnimatePresence>
    </>
  );
};
//#endregion








//#region Expense Account
const AddUpdateExpenseAccountModal = ({
  visible, onClose, onSave, modalName,
  data,
  expenseAccounts, setExpenseAccounts,
}) => {
  const getCurrency = JSON.parse(localStorage.getItem("currency") || "{}");
  const [failMessage, setFailMessage] = useState("");
  const [expenseAccount, setExpenseAccount] = useState(null);
  const [amount, setAmount] = useState(0);
  const [amountTaxType, setAmountTaxType] = useState("");
  const [taxationCode, setTaxationCode] = useState(null);

  const [applyVat, setApplyVat] = useState(false);
  const [vatableAmount, setVatableAmount] = useState(0);
  const [taxAmount, setTaxAmount] = useState(0);
  const [subTotal, setSubTotal] = useState(0);
  const [ewt, setEWT] = useState(0);
  const [totalDiscount, setTotalDiscount] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);

  const [showExpenseAccountSelectForm, setShowExpenseAccountSelectForm] = useState(false);
  const openExpenseAccountSelectForm = () => {
    setShowExpenseAccountSelectForm(true);
  }
  const closeExpenseAccountSelectForm = () => {
    setShowExpenseAccountSelectForm(false);
  }

  const handleSubmit = async () => {
    // Logic updated to match your state requirements
    if (!expenseAccount) {
      setFailMessage("Please fill up all required fields (Expense Account, Paid Through, and Amount).");
      return;
    }

    if(modalName === "Add Expense Account"){
      const foundData = expenseAccounts.find(i => i.expenseAccountId === expenseAccount.id)

      if (foundData) {
        setFailMessage("Already added this account.");
        return;
      }

      const newData = {
        expenseAccountId: expenseAccount?.id,
        expenseAccountName: expenseAccount?.accountName,
        expenseAccount: expenseAccount,
        amount: amount ?? 0,
        amountTaxType: amountTaxType,
        taxationCodeId: taxationCode?.id,
        taxationCodeDescription: taxationCode?.description,
        taxationCode: taxationCode,
        totalAmount: totalAmount,
        vat: taxAmount,
        ewt: ewt,
        discounts: totalDiscount,
      }

      setExpenseAccounts((prev) => [...prev, newData])
    }

    if(modalName === "Update Expense Account"){
      const foundData = expenseAccounts.find(i => i.expenseAccountId === expenseAccount.id && data?.expenseAccountId !== expenseAccount.id)

      if (foundData) {
        setFailMessage("Already added this account.");
        return;
      }

      const newData = {
        expenseAccountId: expenseAccount?.id,
        expenseAccountName: expenseAccount?.accountName,
        expenseAccount: expenseAccount,
        amount: amount ?? 0,
        amountTaxType: amountTaxType,
        taxationCodeId: taxationCode?.id,
        taxationCodeDescription: taxationCode?.description,
        taxationCode: taxationCode,
        totalAmount: totalAmount,
        vat: taxAmount,
        ewt: ewt,
        discounts: totalDiscount,
      }

      setExpenseAccounts(prev =>
        prev.map(item =>
          item.expenseAccountId === data?.expenseAccountId
            ? newData
            : item
        )
      );
    }

    closeModal();
  };

  const resetLocalVariables = () => {
    setExpenseAccount(null)
    setAmount(0)
    setAmountTaxType("")
    setTaxationCode(null)
    setApplyVat(false)
    setVatableAmount(0)
    setTaxAmount(0)
    setSubTotal(0)
    setTotalDiscount(0)
    setTotalAmount(0)
    setEWT(0)
  }

  const closeModal = () => {
    setFailMessage("");
    onClose();
    resetLocalVariables();
  };

  useEffect(() => {
    if(visible){
      setExpenseAccount(data?.expenseAccount ?? null)
      setAmount(data?.amount ?? 0)
      setAmountTaxType(data?.amountTaxType ?? "")
      setTaxationCode(data?.taxationCode ?? null)
      setApplyVat(data?.vat > 0 ? true : false)
      setTotalDiscount(data?.discounts)
      setTotalAmount(data?.totalAmount)
    }
  }, [visible, data])

  useEffect(() => {
    if(visible){
      const _subTotal = parseFloat(amount);
      setSubTotal(_subTotal)
  
      // VAT Inclusive Computation (12%)
      let _vatableAmount = _subTotal;
      let _vat = 0;
  
      if(applyVat){
        _vatableAmount = _subTotal / 1.12;
        _vat = _subTotal - _vatableAmount;
      }
  
      setVatableAmount(Number(_vatableAmount?.toFixed(2)));
      setTaxAmount(Number(_vat?.toFixed(2)));

      if (taxationCode) {
        const ewtRate = Number((taxationCode?.rate ?? 0) / 100);
        let ewtValue = 0;
        
        ewtValue = _vatableAmount * ewtRate;
        setEWT(ewtValue);
      }

      setTotalAmount((_subTotal ?? 0) - (totalDiscount ?? 0))
    }

  }, [visible, amount, setSubTotal, setTaxAmount, applyVat, taxationCode, totalDiscount])

  if (!visible) return null;

  return (
    <>
      <AnimatePresence>
        <motion.div
          // initial={{ opacity: 0 }}
          // animate={{ opacity: 1 }}
          // exit={{ opacity: 0 }}
          className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm flex items-center justify-center z-50 p-4"
        >
          <motion.div
            initial={{ scale: 0.95, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.95, opacity: 0, y: 20 }}
            className="bg-gray-100 rounded-2xl shadow-2xl w-full max-w-5xl overflow-hidden flex flex-col max-h-[90vh]"
          >
            {/* Header */}
            <div className="px-8 py-5 bg-white border-b border-gray-200 flex justify-between items-center">
              <div>
                <h2 className="text-2xl font-bold text-gray-800 tracking-tight">{modalName}</h2>
                <p className="text-sm text-gray-500">Enter the transaction details below</p>
              </div>
              <button onClick={closeModal} className="text-gray-400 hover:text-gray-600 transition p-2 hover:bg-gray-100 rounded-full">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            {/* Body */}
            <div className="p-8 overflow-y-auto custom-scrollbar">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <>
                  {/* --- Section 1: Entities --- */}
                  <div className="space-y-4 md:col-span-2 mt-2">
                    <h3 className="text-xs font-bold uppercase tracking-wider text-gray-400 border-b pb-1">Basic Details</h3>
                  </div>

                  <div>
                    <label className="block text-sm font-semibold mb-1 text-gray-700">
                      (Dr) Expense Account <span className="text-red-500">*</span>
                    </label>
                    <div className="flex flex-row items-center">
                      <input
                        type="text"
                        placeholder="Select Account"
                        className="w-full border border-gray-300 text-sm rounded-l-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                        value={expenseAccount?.accountName || ""}
                        readOnly
                      />
                      {!expenseAccount ?
                        <button className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg" onClick={openExpenseAccountSelectForm}>
                          <ManageSearchIcon className="text-white"/>
                        </button> 
                        :
                        <button className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg" onClick={()=>setExpenseAccount(null)}>
                          <RemoveCircleIcon className="text-white"/>
                        </button>
                      }
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-semibold mb-1 text-gray-700">
                      Amount
                    </label>
                    <input
                      type="number"
                      className="text-sm w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color transition"
                      value={amount}
                      onChange={(e) => setAmount(e.target.value)}
                    />
                    <div className="text-xs text-gray-500 flex items-center gap-1">
                      <span className="font-semibold text-gray-400 italic">
                        {getCurrency?.symbol ?? ""}
                        {FormatValueToDecimal(amount || 0)}
                      </span>
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-semibold mb-1 text-gray-700">
                      Discount
                    </label>
                    <input
                      type="number"
                      className="text-sm w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color transition"
                      value={totalDiscount}
                      onChange={(e) => setTotalDiscount(e.target.value)}
                    />
                    <div className="text-xs text-gray-500 flex items-center gap-1">
                      <span className="font-semibold text-gray-400 italic">
                        {getCurrency?.symbol ?? ""}
                        {FormatValueToDecimal(totalDiscount || 0)}
                      </span>
                    </div>
                  </div>
                  
                  <div className="hidden">
                    <label className="block text-sm font-semibold mb-1 text-gray-700">
                      Amount Tax Type
                    </label>
                    <TaxTypeSelect data={amountTaxType} setData={setAmountTaxType} isEditable={true}/>
                  </div>

                  <div className="hidden">
                    <label className="block text-sm font-semibold mb-1 text-gray-700">
                      Taxation Code
                    </label>
                    <TaxationCodeSelect data={taxationCode} setData={setTaxationCode} isEditable={true}/>
                  </div>
                </>

                <div className="md:col-span-2">
                  <div className="bg-white border border-gray-200 rounded-2xl p-6 shadow-sm flex flex-col lg:flex-row justify-between items-start lg:items-center gap-6">
                    
                    {/* Left Side: Details Breakdown */}
                    <div className="flex gap-4 w-full lg:w-auto">
                      <div className="bg-theme-color/10 p-3 rounded-xl h-fit">
                        <AccountBalanceWalletIcon className="text-theme-color" />
                      </div>
                      
                      <div className="flex-1 space-y-3">
                        <div>
                          <p className="text-[11px] font-bold uppercase tracking-widest text-gray-400">
                            Transaction Summary
                          </p>
                          <p className="text-xs text-gray-500">Breakdown of all line items</p>
                        </div>

                        {/* Mini Table for Subtotal, Discount, Tax */}
                        <div className="grid grid-cols-1 gap-2 border-t border-gray-50 pt-3">
                          <div className="flex flex-row justify-between items-center gap-8">
                            <span className="text-xs font-medium text-gray-500">APPLY VAT</span>
                            <div className="space-y-4">
                              <div>
                                <button
                                  type="button"
                                  onClick={(e) => setApplyVat(!applyVat)}
                                  className={`relative inline-flex h-5 w-10 items-center rounded-full transition-colors duration-300 focus:outline-none ${
                                    applyVat ? "bg-theme-color" : "bg-gray-400"
                                  }`}
                                >
                                  <span
                                    className={`inline-block h-4 w-4 transform rounded-full bg-white shadow-md transition-transform duration-300 ${
                                      applyVat ? "translate-x-5" : "translate-x-1"
                                    }`}
                                  />
                                </button>
                              </div>
                            </div>
                          </div>

                          <div className="flex justify-between items-center gap-8">
                            <span className="text-xs font-medium text-gray-500">Vatable Amount</span>
                            <span className="text-sm font-semibold text-gray-700">
                              {getCurrency?.symbol} {FormatValueToDecimal(vatableAmount)}
                            </span>
                          </div>

                          <div className="flex justify-between items-center gap-8">
                            <span className="text-xs font-medium text-gray-500">VAT</span>
                            <span className="text-sm font-semibold text-gray-700">
                              {getCurrency?.symbol} {FormatValueToDecimal(taxAmount)}
                            </span>
                          </div>

                          <div className="flex justify-between items-center gap-8">
                            <span className="text-xs font-medium text-gray-500">Subtotal</span>
                            <span className="text-sm font-semibold text-gray-700">
                              {getCurrency?.symbol} {FormatValueToDecimal(subTotal)}
                            </span>
                          </div>
                          
                          <div className="flex justify-between items-center gap-8">
                            <span className="text-xs font-medium text-gray-500">Total Discount</span>
                            <span className="text-sm font-semibold text-red-500">
                              {getCurrency?.symbol} {FormatValueToDecimal(totalDiscount)}
                            </span>
                          </div>

                          <div className="justify-between items-center gap-8 hidden">
                            <span className="text-xs font-medium text-gray-500">Tax Amount</span>
                            <span className="text-sm font-semibold text-gray-700">
                              {getCurrency?.symbol} {FormatValueToDecimal(taxAmount)}
                            </span>
                          </div>

                          <div className="flex justify-between text-xs w-full">
                            <div className="w-full flex flex-col gap-2">
                              <span className="text-gray-500">Taxation Code</span>
                              <div className="w-full">
                                <TaxationCodeSelect data={taxationCode} setData={setTaxationCode} isEditable={true}/>
                              </div>
                            </div>
                          </div>
                          <div className="flex justify-between text-xs">
                            <span className="text-gray-500">EWT</span>
                            <span className="font-semibold text-orange-600">({getCurrency?.symbol} {FormatValueToDecimal(ewt || 0)})</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Right Side: Final Total & Status */}
                    <div className="w-full lg:w-auto text-left lg:text-right border-t lg:border-t-0 pt-4 lg:pt-0 border-gray-100">
                      <p className="text-[10px] font-bold uppercase tracking-widest text-gray-400 mb-1">
                        Final Total Amount
                      </p>
                      <div className="flex items-baseline justify-start lg:justify-end gap-2 mb-2">
                        <span className="text-4xl font-black text-gray-900 tracking-tight">
                          {`${getCurrency?.symbol || ""} ${FormatValueToDecimal(totalAmount)}`}
                        </span>
                      </div>

                      {/* Visual indicator of validation */}
                      {totalAmount > 0 ? (
                        <span className="inline-flex items-center text-[10px] font-bold text-green-600 bg-green-50 px-2.5 py-1 rounded-full uppercase tracking-tight border border-green-100">
                          <span className="mr-1">●</span> Ready to Save
                        </span>
                      ) : (
                        <span className="inline-flex items-center text-[10px] font-bold text-amber-600 bg-amber-50 px-2.5 py-1 rounded-full uppercase tracking-tight border border-amber-100">
                          <span className="mr-1">○</span> No amount detected
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Footer */}
            <div className="px-8 py-6 border-t bg-white flex justify-end items-center space-x-4">
              <button
                onClick={closeModal}
                className="px-6 py-2.5 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-50 transition font-semibold text-sm"
              >
                Cancel
              </button>
              <button
                onClick={handleSubmit}
                className="px-10 py-2.5 rounded-lg bg-theme-color text-white font-bold hover:opacity-90 shadow-lg shadow-theme-color/20 transition active:scale-95 text-sm"
              >
                Save Transaction
              </button>
            </div>
          </motion.div>
        </motion.div>
      </AnimatePresence>
      
      {/* <AccountsPayablesChartOfAccountsSelect  */}
      <ChartOfAccountsSelect 
        visible={showExpenseAccountSelectForm} 
        onClose={closeExpenseAccountSelectForm}
        modalName={"Select Account"}
        data={expenseAccount} setData={setExpenseAccount}
      />

      <div className="fixed top-5 right-5 z-50 flex flex-col space-y-2">
        <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
      </div>
    </>
  );
};
const ViewExpenseAccountModal = ({
  visible, onClose, onSave, modalName,
  expenseAccounts, setExpenseAccounts,
}) => {
  
  const getCurrency = JSON.parse(localStorage.getItem("currency") || "{}");
  const [totalExpenseAmount, setTotalExpenseAmount] = useState(0);

  const closeModal = () => {
    onClose();
  };

  const [currentPageExpenseAccount, setCurrentPageExpenseAccount] = useState(1);

  const headersExpenseAccount = [
    'ACCOUNT', 
    'SUBTOTAL', 
    // 'TAX TYPE', 
    // 'TAX CODE', 
    'ADJUSTMENTS', 
    'TOTAL AMOUNT', 
  ]
  const accessorsExpenseAccount = [
    'expenseAccountName', 
    'amount', 
    // 'amountTaxType', 
    // 'taxationCodeDescription',
    'adjustments',
    'totalAmount', 
  ]

  useEffect(() => {
    const _totalExpenseAmount = expenseAccounts?.reduce((acc, item) => acc + (Number(item.totalAmount) || 0), 0) || 0;
    setTotalExpenseAmount(_totalExpenseAmount)
  }, [expenseAccounts])

  if (!visible) return null;

  return (
    <>
      <AnimatePresence>
        <motion.div
          // initial={{ opacity: 0 }}
          // animate={{ opacity: 1 }}
          // exit={{ opacity: 0 }}
          className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm flex items-center justify-center z-50 p-4"
        >
          <motion.div
            initial={{ scale: 0.95, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.95, opacity: 0, y: 20 }}
            className="bg-gray-100 rounded-2xl shadow-2xl w-full max-w-5xl overflow-hidden flex flex-col max-h-[90vh]"
          >
            {/* Header */}
            <div className="px-8 py-5 bg-white border-b border-gray-200 flex justify-between items-center">
              <div>
                <h2 className="text-2xl font-bold text-gray-800 tracking-tight">{modalName}</h2>
                <p className="text-sm text-gray-500">Transaction details below</p>
              </div>
              <button onClick={closeModal} className="text-gray-400 hover:text-gray-600 transition p-2 hover:bg-gray-100 rounded-full">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            <div className="p-8 overflow-y-auto custom-scrollbar">
              <div className="py-5 space-y-5">
                <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
                  <CreateTable
                    tableName={"Expense Accounts"}
                    headers={headersExpenseAccount}
                    accessors={accessorsExpenseAccount}
                    data={expenseAccounts}
                    actions={[]}
                    currentPage={currentPageExpenseAccount}
                    setCurrentPage={setCurrentPageExpenseAccount}
                    itemsPerPage={10}
                    totalItems={expenseAccounts?.length}
                  />
                </div>
                

                <div className="md:col-span-2">
                  <div className="bg-white border border-gray-200 rounded-2xl p-6 shadow-sm flex flex-col md:flex-row justify-between items-center gap-4">
                    <div className="flex items-center gap-4">
                      <div className="bg-theme-color/10 p-3 rounded-xl">
                        <AccountBalanceWalletIcon className="text-theme-color" />
                      </div>
                      <div>
                        <p className="text-[11px] font-bold uppercase tracking-widest text-gray-400">
                          Total Transaction Amount
                        </p>
                        <p className="text-xs text-gray-500">
                          Sum of all expense line items above
                        </p>
                      </div>
                    </div>

                    <div className="text-center md:text-right">
                      <div className="flex items-baseline justify-center md:justify-end gap-2">
                        <span className="text-3xl font-black text-gray-800 tracking-tight">
                          {`${getCurrency?.symbol ? getCurrency?.symbol : ""} ${FormatValueToDecimal(totalExpenseAmount)}`}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Footer */}
            <div className="px-8 py-6 border-t bg-white flex justify-end items-center space-x-4">
              <button
                onClick={closeModal}
                className="px-6 py-2.5 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-50 transition font-semibold text-sm"
              >
                Cancel
              </button>
            </div>
          </motion.div>
        </motion.div>
      </AnimatePresence>
    </>
  );
};
//#endregion







//#region Paid Through Account
const ViewPaidThroughAccountModal = ({
  visible, onClose, onSave, modalName,
  paidThroughAccounts, setPaidThroughAccounts,
}) => {
  const getCurrency = JSON.parse(localStorage.getItem("currency") || "{}");
  const [totalPaidThroughAmount, setTotalPaidThroughAmount] = useState(0);

  const closeModal = () => {
    onClose();
  };

  const [currentPagePaidThroughAccount, setCurrentPagePaidThroughAccount] = useState(1);

  const headersPaidThroughAccount = [
    'ACCOUNT', 
    'AMOUNT', 
  ]
  const accessorsPaidThroughAccount = [
    'paidThroughAccountName', 
    'amount', 
  ]

  useEffect(() => {
    const _totalPaidThroughAmount = paidThroughAccounts?.reduce((acc, item) => acc + (Number(item.amount) || 0), 0) || 0;
    setTotalPaidThroughAmount(_totalPaidThroughAmount)
  }, [paidThroughAccounts])

  if (!visible) return null;

  return (
    <>
      <AnimatePresence>
        <motion.div
          // initial={{ opacity: 0 }}
          // animate={{ opacity: 1 }}
          // exit={{ opacity: 0 }}
          className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm flex items-center justify-center z-50 p-4"
        >
          <motion.div
            initial={{ scale: 0.95, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.95, opacity: 0, y: 20 }}
            className="bg-gray-100 rounded-2xl shadow-2xl w-full max-w-5xl overflow-hidden flex flex-col max-h-[90vh]"
          >
            {/* Header */}
            <div className="px-8 py-5 bg-white border-b border-gray-200 flex justify-between items-center">
              <div>
                <h2 className="text-2xl font-bold text-gray-800 tracking-tight">{modalName}</h2>
                <p className="text-sm text-gray-500">Transaction details below</p>
              </div>
              <button onClick={closeModal} className="text-gray-400 hover:text-gray-600 transition p-2 hover:bg-gray-100 rounded-full">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            <div className="p-8 overflow-y-auto custom-scrollbar">
              <div className="py-5 space-y-5">
                <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
                  <CreateTable
                    tableName={"Paid Through"}
                    headers={headersPaidThroughAccount}
                    accessors={accessorsPaidThroughAccount}
                    data={paidThroughAccounts}
                    actions={[]}
                    currentPage={currentPagePaidThroughAccount}
                    setCurrentPage={setCurrentPagePaidThroughAccount}
                    itemsPerPage={10}
                    totalItems={paidThroughAccounts?.length}
                  />
                </div>

                <div className="md:col-span-2">
                  <div className="bg-white border border-gray-200 rounded-2xl p-6 shadow-sm flex flex-col md:flex-row justify-between items-center gap-4">
                    <div className="flex items-center gap-4">
                      <div className="bg-theme-color/10 p-3 rounded-xl">
                        <AccountBalanceWalletIcon className="text-theme-color" />
                      </div>
                      <div>
                        <p className="text-[11px] font-bold uppercase tracking-widest text-gray-400">
                          Total Transaction Amount
                        </p>
                        <p className="text-xs text-gray-500">
                          Sum of all paid through line items above
                        </p>
                      </div>
                    </div>

                    <div className="text-center md:text-right">
                      <div className="flex items-baseline justify-center md:justify-end gap-2">
                        <span className="text-3xl font-black text-gray-800 tracking-tight">
                          {`${getCurrency?.symbol ? getCurrency?.symbol : ""} ${FormatValueToDecimal(totalPaidThroughAmount)}`}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Footer */}
            <div className="px-8 py-6 border-t bg-white flex justify-end items-center space-x-4">
              <button
                onClick={closeModal}
                className="px-6 py-2.5 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-50 transition font-semibold text-sm"
              >
                Cancel
              </button>
            </div>
          </motion.div>
        </motion.div>
      </AnimatePresence>
    </>
  );
};
//#endregion









//#region Filter
const FilterModal = ({
  visible, onClose, modalName,
  customerFilter, setCustomerFilter,
  vendorFilter, setVendorFilter,
  statusFilter, setStatusFilter,
}) => {
  const [failMessage, setFailMessage] = useState("");
  const [_customerFilter, _setCustomerFilter] = useState(customerFilter);
  const [_vendorFilter, _setVendorFilter] = useState(vendorFilter);
  const [_statusFilter, _setStatusFilter] = useState(statusFilter);

  useEffect(() => {
    if(visible){
      _setCustomerFilter(customerFilter)
      _setVendorFilter(vendorFilter)
      _setStatusFilter(statusFilter)
    }
  }, [visible, customerFilter, vendorFilter, statusFilter])

  const handleSubmit = async () => {
    setCustomerFilter(_customerFilter);
    setVendorFilter(_vendorFilter);
    setStatusFilter(_statusFilter);
    closeModal();
  };

  const resetLocalVariables = () => {
    setFailMessage("");
  };

  const closeModal = () => {
    onClose();
    resetLocalVariables();
  };

//#region Customer
  const [showCustomerSelectForm, setShowCustomerSelectForm] = useState(false);
  const openCustomerSelectForm = () => {
    setShowCustomerSelectForm(true);
  }
  const closeCustomerSelectForm = () => {
    setShowCustomerSelectForm(false);
  }
//#endregion



//#region Vendor
  const [showVendorSelectForm, setShowVendorSelectForm] = useState(false);
  const openVendorSelectForm = () => {
    setShowVendorSelectForm(true);
  }
  const closeVendorSelectForm = () => {
    setShowVendorSelectForm(false);
  }
//#endregion

  if (!visible) return null;

  return (
    <>
      {/* Background overlay */}
      <AnimatePresence>
        {visible && (
          <motion.div
            // initial={{ opacity: 0 }}
            // animate={{ opacity: 1 }}
            // exit={{ opacity: 0 }}
            className="fixed inset-0 bg-gray-200 bg-opacity-70 flex items-center justify-center z-50"
          >
            {/* Modal container */}
            <motion.div
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
              transition={{ duration: 0.2 }}
              className="bg-gray-100 rounded-2xl shadow-lg w-full max-w-lg p-8"
            >
              <h2 className="text-2xl font-semibold border-b pb-3 mb-6">
                {modalName}
              </h2>

              <div className="space-y-5 max-h-[500px] overflow-y-auto short:max-h-[300px] medium:h-[400px] pr-1">
                <div>
                  <label className="block text-sm font-semibold mb-1 text-gray-700">
                    Vendor <span className="text-red-500">*</span>
                  </label>
                  <div className="flex flex-row items-center">
                    <input
                      type="text"
                      placeholder="Select Vendor"
                      className="w-full border border-gray-300 text-sm rounded-l-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                      value={`${_vendorFilter ? `${_vendorFilter?.vendorId} - ${_vendorFilter?.name1}` : ""}`}
                      readOnly
                    />
                    {!_vendorFilter ?
                      <button className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg" onClick={openVendorSelectForm}>
                        <PersonSearchIcon className="text-white"/>
                      </button> 
                      :
                      <button className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg" onClick={()=>_setVendorFilter(null)}>
                        <RemoveCircleIcon className="text-white"/>
                      </button>
                    }
                  </div>
                </div>

                <div className="hidden">
                  <label className="block text-sm font-semibold mb-1 text-gray-700">
                    Customer <span className="text-red-500">*</span>
                  </label>
                  <div className="flex flex-row items-center">
                    <input
                      type="text"
                      placeholder="Select Customer"
                      className="w-full border border-gray-300 text-sm rounded-l-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                      value={`${_customerFilter ? `${_customerFilter?.customerId} - ${_customerFilter?.name1}` : ""}`}
                      readOnly
                    />
                    {!_customerFilter ?
                      <button className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg" onClick={openCustomerSelectForm}>
                        <PersonSearchIcon className="text-white"/>
                      </button> 
                      :
                      <button className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg" onClick={()=>_setCustomerFilter(null)}>
                        <RemoveCircleIcon className="text-white"/>
                      </button>
                    }
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium mb-1 text-gray-700">
                    Status
                  </label>
                  <PaymentStatusSelectWithAll data={_statusFilter} setData={_setStatusFilter} isEditable={true}/>
                </div>
              </div>

              {/* Buttons */}
              <div className="flex justify-end space-x-3 mt-8 border-t pt-4">
                <button
                  onClick={closeModal}
                  className="px-5 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-100 transition"
                >
                  Cancel
                </button>
                <button
                  onClick={handleSubmit}
                  className="px-5 py-2 rounded-lg bg-theme-color text-white font-medium hover:opacity-90 transition"
                >
                  Save
                </button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      <CustomerSelect 
        visible={showCustomerSelectForm} 
        onClose={closeCustomerSelectForm}
        modalName={"Select Customer"}
        data={_customerFilter} setData={_setCustomerFilter}
      />

      <VendorSelect 
        visible={showVendorSelectForm} 
        onClose={closeVendorSelectForm}
        modalName={"Select Vendor"}
        data={_vendorFilter} setData={_setVendorFilter}
      />

      {/* Alert */}
      <div className="fixed top-5 right-5 z-[9999] flex flex-col space-y-2">
        <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
      </div>
    </>
  );
};
//#endregion











//#region Journal
const CreateJournalModal = ({
  visible, onClose, onSave, modalName,
  data, fetchData,
  isEditable, status,
}) => {
  const [successMessage, setSuccessMessage] = useState("");
  const [failMessage, setFailMessage] = useState("");
  const [loading, setLoading] = useState(false)
  const [journalLines, setJournalLines] = useState([])
  const [documentNumber, setDocumentNumber] = useState("") 
  const [vendor, setVendor] = useState(null) 
  const [customer, setCustomer] = useState(null)
  const [documentType, setDocumentType] = useState(null)
  const [documentDate, setDocumentDate] = useState(null)
  const today = new Date().toISOString().split("T")[0];
  const [postingDate, setPostingDate] = useState(today)
  const [fiscalYear, setFiscalYear] = useState("")
  const [fiscalPeriod, setFiscalPeriod] = useState("")
  const [currency, setCurrency] = useState("PHP")
  const [referenceNumber, setReferenceNumber] = useState("")
  const [documentHeaderText, setDocumentHeaderText] = useState("")

  const generateNumber = useCallback(async () => {
    try {
      const response = await axios.get(`${apiUrl}/api/Journal/generate-number` , {
        headers: { 'Content-Type': 'application/json'}
      })
        
      return (response.data)
    } catch (error) {
      console.error('Error fetching data:', error);
      return ""
    }
  }, []);

  const fetchNumber = useCallback(async () => {
    setLoading(true)

    const _number = await generateNumber();
    setDocumentNumber(_number?.number)

    setLoading(false)
  }, [generateNumber])

  useEffect(() => {
    if (visible && !documentNumber) {
      fetchNumber()
      setVendor(data?.vendor ?? null)
      setCustomer(data?.customer ?? null)

      const _documentType = {
        id: 1,
        description: "Accounts Payable",
        isActive: true
      }

      setDocumentType(_documentType)
      setDocumentDate(data?.documentDate)
      setReferenceNumber(data?.documentNumber)
    }
  }, [visible, documentNumber, fetchNumber, data])

  const accountData = JSON.parse(localStorage.getItem("accountData"));

  const handleAddData = async () => {
    const data = {
      journalLines: journalLines,
      vendorId: vendor?.vendorId,
      customerId: customer?.customerId,
      documentNumber: documentNumber,
      documentTypeId: documentType?.id,
      documentSubType: "Expense",
      documentDate: documentDate,
      postingDate: postingDate,
      fiscalYear: fiscalYear,
      fiscalPeriod: fiscalPeriod,
      currency: currency,
      referenceNumber: referenceNumber,
      documentHeaderText: documentHeaderText,
      createdDate: new Date(),
      createdBy: accountData?.id,
    };

    try {
      setLoading(true);

      await axios.post(`${apiUrl}/api/Journal/status/${status}`, data, {
          headers: { 'Content-Type': 'application/json' }
      });
      
      await fetchData();
      setSuccessMessage("Data added successfully!");
    } catch (error) {
      console.error('There was a problem adding data:', error);
      const errorMessage = JSON.parse(error.response.request.responseText).message;
      setFailMessage(`Failed to add data: ${errorMessage}`);
    } finally {
      setLoading(false);
    }
  } 

  const handleSubmit = async () => {
    if(!documentNumber
      || !documentType
      || !postingDate
      || !currency
      || journalLines.length <= 0
    ){
      setFailMessage("Please fill up all required fields.")
      return;
    }

    await handleAddData();
    closeModal();
  };

  const resetLocalVariables = () => {
    setJournalLines([])
    setDocumentNumber("")
    setVendor(null)
    setCustomer(null)
    setDocumentType(null)
    setDocumentDate(null)
    setPostingDate(today)
    setFiscalYear("")
    setFiscalPeriod("")
    setCurrency("PHP")
    setReferenceNumber("")
    setDocumentHeaderText("")
  }

  const closeModal = () => {
    onClose();
    resetLocalVariables();
  }

  if (!visible) return null;

  return (
    <>
      <AnimatePresence>
        <motion.div
          // initial={{ opacity: 0 }}
          // animate={{ opacity: 1 }}
          // exit={{ opacity: 0 }}
          className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm flex items-center justify-center z-50 p-4"
        >
          <motion.div
            initial={{ scale: 0.95, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.95, opacity: 0, y: 20 }}
            className="bg-gray-100 rounded-2xl shadow-2xl w-full max-w-7xl overflow-hidden flex flex-col max-h-[90vh]"
          >
            {/* Header */}
            <div className="px-8 py-5 bg-white border-b border-gray-200 flex justify-between items-center">
              <div>
                <h2 className="text-2xl font-bold text-gray-800 tracking-tight">{`${modalName}`}</h2>
                <p className="text-sm text-gray-500">{`Document Number: ${documentNumber}`}</p>
              </div>
              <button onClick={closeModal} className="text-gray-400 hover:text-gray-600 transition p-2 hover:bg-gray-100 rounded-full">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            {/* Body */}
            <div className="p-8 overflow-y-auto custom-scrollbar">
              <JournalHeader 
                type={"AP"}
                isEditable={true}
                documentNumber={documentNumber} setDocumentNumber={setDocumentNumber}
                journalLines={journalLines} setJournalLines={setJournalLines}
                vendor={vendor} setVendor={setVendor}
                customer={customer} setCustomer={setCustomer}
                documentType={documentType} setDocumentType={setDocumentType}
                documentDate={documentDate} setDocumentDate={setDocumentDate}
                postingDate={postingDate} setPostingDate={setPostingDate}
                fiscalYear={fiscalYear} setFiscalYear={setFiscalYear}
                fiscalPeriod={fiscalPeriod} setFiscalPeriod={setFiscalPeriod}
                currency={currency} setCurrency={setCurrency}
                referenceNumber={referenceNumber} setReferenceNumber={setReferenceNumber}
                documentHeaderText={documentHeaderText} setDocumentHeaderText={setDocumentHeaderText}
                documentData={data}
              />
            </div>

            {/* Footer */}
            <div className="px-8 py-6 border-t bg-white flex justify-end items-center space-x-4">
              <button
                onClick={closeModal}
                className="px-6 py-2.5 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-50 transition font-semibold text-sm"
              >
                Cancel
              </button>
              {isEditable &&
                <button
                  onClick={handleSubmit}
                  className="px-10 py-2.5 rounded-lg bg-theme-color text-white font-bold hover:opacity-90 shadow-lg shadow-theme-color/20 transition active:scale-95 text-sm"
                >
                  Create Journal
                </button>
              }
            </div>
          </motion.div>
        </motion.div>
      </AnimatePresence>

      <div className="fixed top-5 right-5 z-50 flex flex-col space-y-2">
        <SuccessMessage message={successMessage} onClose={() => setSuccessMessage("")} />
        <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
      </div>

      { loading && <Loading />}
    </>
  );
};
//#endregion